import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import imageCompression from "browser-image-compression";
import load from "../../assets/Images/loader.gif";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Swal from "sweetalert2";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";



// const minDate = new Date().toISOString().split("T")[0];
// const maxDate = new Date(new Date().setDate(new Date().getDate() + 5)).toISOString().split("T")[0];


const optionAddressProof = [
    { value: "AADHAR", label: "Aadhar" },
    { value: "GST", label: "Address in GST Certificate" },
    { value: "Lease", label: "Lease Deed" },
    { value: "LOI", label: "LOI" },
    { value: "Deed", label: "Rent Deed" },
    { value: "Tax", label: "Tax Receipt" },
    { value: "Bill", label: "Utility Bill" },
]

const optionPhotoProof = [
    { value: "AADHAR", label: "Aadhar Card", required: true },
    { value: "LICENSE", label: "Driving license", required: true },
    { value: "GOVTIDCARD", label: "Govt. ID card", required: true },
    { value: "PASSPORT", label: "Passport", required: true },
    { value: "PAN", label: "Pan card", required: true },
    { value: "VOTERID", label: "Voter ID", required: true },
];

// const optionPoi = [
//     { value: "AADHAR", label: "Aadhar" },
//     { value: "LICENSE", label: "DL" },
//     { value: "PAN", label: "Pan" },
//     { value: "GOVTIDCARD", label: "Govt. Official ID" },
//     { value: "VOTERID", label: "Voter ID" },
// ]

const GstOpts = [
    // { value: "0", label: "Select Option" },
    { value: "569480000", label: "Yes" },
    { value: "569480001", label: "No" },
];

const DecOpts = [
    { value: "0", label: "text" },
];

// const firmType = sessionStorage.getItem('firmtype')
// const firmType = "3";
// console.log("firmType", firmType)
// const cafSafNo = "CAF_H_103";//CAF_H_2495

const BusinessSAFmanageFormDOC = () => {
    const style = {
        control: (base) => ({
            ...base,
            border: 0,
            // This line disable the blue border
            boxShadow: "none",
        }),
    };
    const [getopportunity, setopportunity] = useState();
    const [uploadedCafFile, setUploadedCafFile] = useState("");
    const [uploadedNetworkFile, setUploadedNetworkFile] = useState("");
    const [uploadedCoiFile, setUploadedCoiFile] = useState("");
    const [uploadedPanFile, setUploadedPanFile] = useState("");
    const [uploadedTanFile, setUploadedTanFile] = useState("");
    const [uploadedGstFile, setUploadedGstFile] = useState("");
    const [uploadedRegFile, setUploadedRegFile] = useState("");
    const [uploadedPoiFile, setUploadedPoiFile] = useState("");
    const [uploadedPhotoFile, setUploadedPhotoFile] = useState("");
    const [uploadedAddressFile, setUploadedAddressFile] = useState("");
    const [uploadedPurchseFile, setUploadedPurchseFile] = useState("");
    const [uploadedpartnerDeedFile, setUploadedpartnerDeedFile] = useState("");
    const [uploadedAuthFile, setUploadedAuthFile] = useState("");
    const [uploadedPoFile, setUploadedPoFile] = useState("");
    const [uploadedDeedFile, setUploadedDeedFile] = useState("");
    const [loading, setLoading] = useState(false);
    const [attachedFile, setAttachedFile] = useState([]);
    const [base64Strings, setBase64Strings] = useState([]);
    const [fileName, setFileName] = useState([]);
    const [selectAddressProof, setSelectAddressProof] = useState([]);
    const [selectPhotoProof, setSelectPhotoProof] = useState([]);
    const [selectPoi, setSelectPoi] = useState([]);
    const [coiDocVerify, setCoiDocVerify] = useState("");
    const [purchaseDocVerify, setPurchaseDocVerify] = useState("");
    const [partnerDeedDocVerify, setPartnerDeedDocVerify] = useState("");
    const [cafReportDocVerify, setCafReportDocVerify] = useState("");
    const [panDocVerify, setPanDocVerify] = useState("");
    const [deedDocVerify, setDeedDocVerify] = useState("");
    const [gstDocVerify, setGstDocVerify] = useState("");
    const [tanDocVerify, setTanDocVerify] = useState("");
    const [registationDocVerify, setRegistationDocVerify] = useState("");
    const [poDocVerify, setPoDocVerify] = useState("");
    const [networkDocVerify, setNetworkDocVerify] = useState("");
    const [poiDocVerify, setPoiDocVerify] = useState("");
    const [addressDocVerify, setAddressDocVerify] = useState("");
    const [photoDocVerify, setPhotoDocVerify] = useState("");
    const [authLetterDocVerify, setAuthLetterDocVerify] = useState("");
    const [selectGst, setSelectGst] = useState("");
    const [selectDec, setSelectDec] = useState();
    const [cafDocData, setCafDocData] = useState({
        cafNo: "",
        coiNum: "",
        coiDoc: "",
        purchaseNum: "",
        purchaseDoc: "",
        partnerDeedNum: "",
        partnerDeedDoc: "",
        cafReportNum: "",
        cafReportDoc: "",
        panNum: "",
        panDoc: "",
        deedNum: "",
        deedDoc: "",
        gstNum: "",
        gstDoc: "",
        tanNum: "",
        registationNum: "",
        tanDoc: "",
        registationDoc: "",
        poiNum: "",
        poiDoc: "",
        authLetterNum: "",
        authLetterDoc: "",
        addressProofNum: "",
        photoProofNum: "",
        panDate: "",
        deedDate: "",
        poDate: "",
        coiDate: "",
        purchaseDate: "",
        partnerDeedDate: "",
        cafReportDate: "",
        gstDate: "",
        tanDate: "",
        registationDate: "",
        poiDate: "",
        authLetterDate: "",
        addressProofdate: "",
        addressProofDoc: "",
        photoProofdate: "",
        photoProofDoc: "",
        coiDocRej: "",
        purchaseDocRej: "",
        partnerDeedDocRej: "",
        cafReportDocRej: "",
        panDocRej: "",
        deedDocRej: "",
        tanDocRej: "",
        registationDocRej: "",
        gstDocRej: "",
        poiDocRej: "",
        addressDocRej: "",
        photoDocRej: "",
        authDocRej: "",
        poNum: "",
        poDoc: "",
        poDocRej: "",
        networkNum: "",
        networkDoc: "",
        networkDocRej: "",
    });
    const [isCheckboxChecked, setIsCheckboxChecked] = useState({
        panCheck: false,
        deedCheck: false,
        coiCheck: false,
        purchaseCheck: false,
        partnerDeedCheck: false,
        cafReportCheck: false,
        gstCheck: false,
        tanCheck: false,
        registationCheck: false,
        poiCheck: false,
        addressProofCheck: false,
        photoProofCheck: false,
        authLetterCheck: false,
        poCheck: false
    });

    const [panCompany, setPanCompany] = useState("");
    const [panCompanyId, setPanCompanyId] = useState("");
    const [panGroup, setPanGroup] = useState("");
    const [panGroupId, setPanGroupId] = useState("");

    const [autherName, setAutherName] = useState("");
    const [firmType, setFirmType] = useState("");



    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const cafSafNo = searchParams.get("SafNo");
    const OppId = searchParams.get("OppId");

    const handleIsGst = (selectedOption) => {
        setSelectGst(selectedOption);
    };

    const handleGstDeclaration = async (selectedOption) => {
        setSelectDec(selectedOption);

        try {
            const apiUrl = process.env.REACT_APP_API_URL_3;
            const requestPayload = {
                "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                "Action": "uploadDocDigitalCaf",
                "password": sessionStorage.getItem('password'),
                "userName": sessionStorage.getItem('userName'),
                "CafSafNo": cafSafNo,
                "data": [
                    {
                        "DocumentName": "GST Number",
                        "DocumentNumber": "",
                        "PendingDocSubmitOn": "",
                        "fileNameWithExtension": "",
                        "fileContent": "",
                        "IsGSTapplicable": selectGst.label ? selectGst.label : "",
                        "GSTDeclaration": selectedOption.label ? selectedOption.label : ""
                    }
                ]
            };

            // console.log("Sending request:", requestPayload);

            const response = await fetch(apiUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(requestPayload),
            });

            const result = await response.json();
            // console.log("API Response:", result);

        } catch (error) {
            console.error("Error in handleGstDeclaration API:", error);
        }
    };

    const handleChange = (e) => {
        // console.log(e.target.name, e.target.value);
        setCafDocData({ ...cafDocData, [e.target.name]: e.target.value });
    };
    const handleCheckboxChange = (e) => {
        const { name, checked } = e.target; // Extract name and checked properties
        setIsCheckboxChecked((prevState) => ({
            ...prevState,
            [name]: checked, // Update the specific checkbox state
        }));

        if (checked) {
            toast.warning("Please Select Date", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
            });
        }
    };

    // const [requiredDocFlag, setRequiredDocFlag] = useState([
    //     {
    //         value: "0",
    //         label: "Select Firm Type",
    //         docName: {}
    //     },
    //     {
    //         value: "1",
    //         label: "Proprietorship",
    //         docName: {
    //             "PhotoProof": true,
    //             "GSTNumber": true,
    //             "CAFReport": true,
    //             // Paf:true,
    //             // Caf:true,
    //         }
    //     },
    //     {
    //         value: "2",
    //         label: "Partnership",
    //         docName: {
    //             "PhotoProof": true,
    //             "GSTNumber": true,
    //             "Registation Certificate": true,
    //             "CAFReport": true,
    //             // Paf:true,
    //             // Caf:true,
    //         }
    //     },
    //     {
    //         value: "3", label: "Pvt Ltd",
    //         docName: {
    //             "PhotoProof": true,
    //             // "Authorisationletter": true,
    //             "GSTNumber": true,
    //             // "PO": true,
    //             // "CAFReport": true,
    //             // Paf:true,
    //             // Caf:true,
    //         }
    //     },
    //     {
    //         value: "4", label: "Ltd",
    //         docName: {
    //             "PhotoProof": true,
    //             "Authorisationletter": true,
    //             "GSTNumber": true,
    //             "PO": true,
    //             "CAFReport": true,
    //             // Paf:true,
    //             // Caf:true,
    //         }
    //     },
    //     {
    //         value: "5",
    //         label: "Trust",
    //         docName: {
    //             // TrustDeed: true,
    //             "CAFReport": true,
    //             // Paf:true,
    //             // Caf:true,
    //         }
    //     },
    //     {
    //         value: "6",
    //         label: "Individual",
    //         docName: {
    //             "PhotoProof": true,
    //             "PO": true,
    //             "CAFReport": true,
    //         }
    //     },
    // ])


    // const handleSubmitDocument = () => {
    //     // Document Submit checks
    //     const requiredDocListFlags = requiredDocFlag[firmType].docName;
    //     // alert(requiredDocListFlags);

    //     console.log("Document Submit: ", isSubmitSucess);
    //     console.log("Document Required: ", requiredDocListFlags);
    //     let isSubmitSucess1 = { PurchaseOrder: true };
    //     console.log("isSubmitSucess1", isSubmitSucess1);

    //     const missingFields = Object.keys(requiredDocListFlags)
    //         .filter(
    //             (key) =>
    //                 requiredDocListFlags[key] === true && // Check if the field is required
    //                 (!isSubmitSucess[key] || isSubmitSucess[key] === false) // Check if the field is missing or failed
    //         ).map(key =>
    //             key
    //                 .replace(/([A-Z])/g, ' $1') // Add space before uppercase letters
    //                 .replace(/^./, str => str.toUpperCase()) // Capitalize the first letter
    //         );

    //     if (missingFields.length > 0) {
    //         const message = `Required Documents Missing!
    //              ${missingFields
    //                 .map((field) => `|| ${field.replace(/([A-Z])/g, ' $1')}`) // Add spaces before uppercase letters for readability
    //                 .join("\n")}`;

    //         // Show SweetAlert
    //         Swal.fire({
    //             // title: "Required Documents Missing!",
    //             text: message,
    //             icon: "warning",
    //             button: "OK",
    //         });
    //     } else {
    //         Swal.fire({
    //             // title: "All Documents Submitted!",
    //             text: "Documents have been submitted successfully.",
    //             icon: "success",
    //             button: "OK",
    //         });
    //     }
    //     console.log(missingFields);

    // }


    // const updateRequiredDoc = (result) => {
    //     let verifiedDocs = result.Response.data.filter((doc) => doc.ApprovalStatus == "Verified").map(doc => doc.DocumentName);

    //     console.log(verifiedDocs);
    //     if (Array.isArray(verifiedDocs) && verifiedDocs.length > 0) {
    //         setRequiredDocFlag((prevState) =>
    //             prevState.map((item, index) => {
    //                 if (index === firmType) { // Targeting "Pvt Ltd" (requiredDocFlag[3])
    //                     return {
    //                         ...item,
    //                         docName: Object.keys(item.docName).reduce((updatedDocName, key) => {
    //                             updatedDocName[key] = !verifiedDocs?.includes(key);
    //                             return updatedDocName;
    //                         }, {})
    //                     };
    //                 }
    //                 return item;
    //             })
    //         );
    //     }
    // };


    const handleSelectAddressProof = (selectOption) => {
        setSelectAddressProof(selectOption);
    };

    const handleSelectPhotoProof = (selectOption) => {
        setSelectPhotoProof(selectOption);
    };

    const handleSelectPoi = (selectOption) => {
        setSelectPoi(selectOption);
    };


    const handleSubmitDoc = () => {
        setLoading(true); // Show loader

        setTimeout(() => {
            toast.success("Document uploaded Successfully", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 1500,
            });
        }, 5000);

        setTimeout(() => {
            setLoading(false); // Hide loader before navigating
            navigate("/saf");
        }, 6500); // Delay navigation slightly to ensure loader is turned off
    };





    const uploadDocDigitalCaf = async (payload) => {
        try {
            const apiUrl = process.env.REACT_APP_API_URL_3;
            let request = {
                "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                "Action": "uploadDocDigitalCaf",
                "password": sessionStorage.getItem('password'),
                "userName": sessionStorage.getItem('userName'),
                "CafSafNo": cafSafNo,
            };
            // Construct the data array conditionally
            let data = [
                {
                    "DocumentName": payload.DocumentName,
                    "DocumentNumber": payload.DocumentNumber,
                    "PendingDocSubmitOn": "", // "2024-11-21"
                    "fileNameWithExtension": payload.fileNameWithExtension,
                    "fileContent": payload.fileContent,
                    "IsGSTapplicable": "",
                    "GSTDeclaration": "",
                }
            ];

            if (selectGst.label == "Yes") {
                // data[0]["IsGSTapplicable"] = selectGst.label;
                // data[0]["GSTDeclaration"] = "";
                data = [
                    {
                        "DocumentName": payload.DocumentName,
                        "DocumentNumber": payload.DocumentNumber,
                        "PendingDocSubmitOn": "", // "2024-11-21"
                        "fileNameWithExtension": payload.fileNameWithExtension,
                        "fileContent": payload.fileContent,
                        "IsGSTapplicable": payload.IsGSTapplicable,
                        "GSTDeclaration": "",
                    }
                ];
            }

            request["data"] = data;
            // console.log("request: ", request);
            const response = await fetch(apiUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(request),
            });
            const result = await response.json();
            // console.log("uploadDocDigitalCaf: ", result);
            let docNameStr = payload.DocumentName.replace(/\s+/g, '');
            // console.log("docNameStr", docNameStr);
            // console.log("result.Response.StatusCode", result.Response.StatusCode);
            if (result.Response.StatusCode == 200) {
                toast.success(result.Response.Message, {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                });
            }

        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };




    const handleFileUpload = async (event, docName) => {
        const selectedFile = event.target.files[0];
        // console.log(cafDocData.coiNum, docName);
        // console.log("selectedFile.name", selectedFile.name);
        const fileExtension = `.${selectedFile.name.split('.').pop()}`;
        // console.log("fileExtension", fileExtension);
        // let fileNameWithExtension = selectedFile.name;
        let fileNameWithExtension;
        let documentName;
        let documentNumber;

        switch (docName) {
            case "authorisationLetter":
                documentName = "Authorisation letter";
                documentNumber = cafDocData.authLetterNum;
                fileNameWithExtension = `Authorisation${fileExtension}`;
                setUploadedAuthFile(fileNameWithExtension);
                break;
            case "deedNumber":
                documentName = "Trust Deed";
                documentNumber = cafDocData.deedNum;
                fileNameWithExtension = `DEED${fileExtension}`;
                setUploadedDeedFile(fileNameWithExtension);
                break;
            case "poi":
                documentName = "POI";
                documentNumber = cafDocData.poiNum;
                // fileNameWithExtension = `Poi${fileExtension}`
                if (selectPoi?.value) {
                    fileNameWithExtension = `${selectPoi.value}${fileExtension}`;
                } else {
                    fileNameWithExtension = `POI${fileExtension}`
                }
                setUploadedPoiFile(fileNameWithExtension);
                break;
            case "addressProof":
                documentName = "Address Proof";
                documentNumber = cafDocData.addressProofNum;
                if (selectAddressProof?.value) {
                    fileNameWithExtension = `${selectAddressProof.value}${fileExtension}`;
                } else {
                    fileNameWithExtension = `Address${fileExtension}`
                }
                setUploadedAddressFile(fileNameWithExtension);
                break;
            case "photoProof":
                documentName = "Photo Proof";
                documentNumber = cafDocData.photoProofNum;
                if (selectPhotoProof?.value) {
                    fileNameWithExtension = `${selectPhotoProof.value}${fileExtension}`;
                } else {
                    fileNameWithExtension = `Photo${fileExtension}`
                }
                // fileNameWithExtension = `Photo${fileExtension}`
                setUploadedPhotoFile(fileNameWithExtension);
                break;
            case "gstNumber":
                documentName = "GST Number";
                documentNumber = cafDocData.gstNum;
                fileNameWithExtension = `GST${fileExtension}`
                setUploadedGstFile(fileNameWithExtension);
                break;
            case "panNumber":
                documentName = "Company PAN Number";
                documentNumber = cafDocData.panNum;
                fileNameWithExtension = `PAN${fileExtension}`;
                setUploadedPanFile(fileNameWithExtension);
                break;
            case "tanNumber":
                documentName = "TAN Number";
                documentNumber = cafDocData.tanNum;
                fileNameWithExtension = `TAN${fileExtension}`;
                setUploadedTanFile(fileNameWithExtension);
                break;
            case "registationNumber":
                documentName = "Registation Certificate";
                documentNumber = cafDocData.registationNum;
                fileNameWithExtension = `RegDoc${fileExtension}`;
                setUploadedRegFile(fileNameWithExtension);
                break;
            case "coi":
                documentName = "COI";
                documentNumber = cafDocData.coiNum;
                fileNameWithExtension = `COI${fileExtension}`;
                setUploadedCoiFile(fileNameWithExtension)
                break;

            case "po":
                documentName = "PO";
                documentNumber = cafDocData.poNum;
                fileNameWithExtension = `PO${fileExtension}`
                setUploadedPurchseFile(fileNameWithExtension);
                break;

            case "pd":
                documentName = "PD";
                documentNumber = cafDocData.partnerDeedNum;
                fileNameWithExtension = `PD${fileExtension}`
                setUploadedpartnerDeedFile(fileNameWithExtension);
                break;

            case "cafReport":
                documentName = "CAF Report";
                documentNumber = cafDocData.cafReportNum;
                fileNameWithExtension = `CAFReport${fileExtension}`;
                setUploadedCafFile(fileNameWithExtension);
                break;
            case "networkDiagram":
                documentName = "Network Diagram";
                documentNumber = cafDocData.networkNum;
                fileNameWithExtension = `NetworkDiagram${fileExtension}`;
                setUploadedNetworkFile(fileNameWithExtension);
                break;
        }

        // Check if the selected file is an image or a PDF
        const isImage = selectedFile.type.startsWith("image/");
        const isPdf = selectedFile.type === "application/pdf";

        // Handle image files
        if (isImage) {
            const options = {
                maxSizeMB: 1, // Maximum file size in MB
                maxWidthOrHeight: 1920, // Max width or height
                useWebWorker: true, // Use web worker for faster compression
            };

            try {
                const compressedFile = await imageCompression(selectedFile, options);
                setAttachedFile(compressedFile.name);
                const reader = new FileReader();

                reader.onloadend = async () => {
                    let base64String = reader.result;
                    if (base64String) {
                        const prefixIndex = base64String.indexOf(";base64,");
                        if (prefixIndex !== -1) {
                            base64String = base64String.slice(prefixIndex + 8); // +8 to remove the prefix including ";base64,"
                        }
                        base64String = base64String.replace(/^"|"$/g, "");
                        setBase64Strings(base64String);
                        // await handleDocumentSave(base64String, selectedFile.name);
                        if (selectGst.label == "Yes") {
                            await uploadDocDigitalCaf({
                                "CafNo": cafDocData.cafNo,
                                "DocumentName": documentName,
                                "DocumentNumber": documentNumber,
                                "PendingDocSubmitOn": "",  // 2024-11-21
                                "fileNameWithExtension": fileNameWithExtension,
                                "fileContent": base64String,
                                "IsGSTapplicable": docName == "gstNumber" ? selectGst.label : "",
                                "GSTDeclaration": "",
                            });
                        } else {
                            await uploadDocDigitalCaf({
                                "CafNo": cafDocData.cafNo,
                                "DocumentName": documentName,
                                "DocumentNumber": documentNumber,
                                "PendingDocSubmitOn": "",  // 2024-11-21
                                "fileNameWithExtension": fileNameWithExtension,
                                "fileContent": base64String,
                                "IsGSTapplicable": "",
                                "GSTDeclaration": "",
                            });
                        }
                    } else {
                        // console.log("Base64 string is empty or undefined");
                    }
                };
                reader.readAsDataURL(compressedFile);
                // console.log([compressedFile.name]);

                setFileName([compressedFile.name]);
            } catch (error) {
                console.error("Error during image compression:", error);
            }

            // Handle PDF files
        } else if (isPdf) {
            setAttachedFile(selectedFile.name);
            const reader = new FileReader();
            reader.onloadend = async () => {
                let base64String = reader.result;
                if (base64String) {
                    const prefixIndex = base64String.indexOf(";base64,");
                    if (prefixIndex !== -1) {
                        base64String = base64String.slice(prefixIndex + 8); // +8 to remove the prefix including ";base64,"
                    }
                    base64String = base64String.replace(/^"|"$/g, "");
                    // console.log("base64String", base64String);

                    setBase64Strings(base64String);

                    if (selectGst.label == "Yes") {
                        await uploadDocDigitalCaf({
                            "CafNo": cafDocData.cafNo,
                            "DocumentName": documentName,
                            "DocumentNumber": documentNumber,
                            "PendingDocSubmitOn": "",  // 2024-11-21
                            "fileNameWithExtension": fileNameWithExtension,
                            "fileContent": base64String,
                            "IsGSTapplicable": docName == "gstNumber" ? selectGst.label : "",
                            "GSTDeclaration": "",
                        });
                    } else {
                        await uploadDocDigitalCaf({
                            "CafNo": cafDocData.cafNo,
                            "DocumentName": documentName,
                            "DocumentNumber": documentNumber,
                            "PendingDocSubmitOn": "",  // 2024-11-21
                            "fileNameWithExtension": fileNameWithExtension,
                            "fileContent": base64String,
                            "IsGSTapplicable": "",
                            "GSTDeclaration": "",
                        });
                    }
                } else {
                    // console.log("Base64 string is empty or undefined");
                }
            };

            reader.readAsDataURL(selectedFile);
            // console.log([selectedFile]);
            setFileName([selectedFile.name]);
        } else {
            console.error("Unsupported file type");
        }
    };

    // const formatDateForInput = (date) => {
    //     if (!date) return ""; // If the date is empty, return an empty string
    //     const [year, day, month] = date.split("-");
    //     return `${year}-${month}-${day}`; // Rearrange to yyyy-MM-dd
    // };

    const [selectedCoiDate, setSelectedCoiDate] = useState(
        cafDocData.coiDate ? new Date(cafDocData.coiDate) : null
    );
    const [selectedDeedDate, setSelectedDeedDate] = useState(
        cafDocData.deedDate ? new Date(cafDocData.deedDate) : null
    );
    const [selectedPartnerDeedDate, setSelectedPartnerDeedDate] = useState(
        cafDocData.partnerDeedDate ? new Date(cafDocData.partnerDeedDate) : null
    );
    const [selectedPanDate, setSelectedPanDate] = useState(
        cafDocData.panDate ? new Date(cafDocData.panDate) : null
    );
    const [selectedGstDate, setSelectedGstDate] = useState(
        cafDocData.gstDate ? new Date(cafDocData.gstDate) : null
    );
    const [selectedTanDate, setSelectedTanDate] = useState(
        cafDocData.tanDate ? new Date(cafDocData.tanDate) : null
    );
    const [selectedRegDate, setSelectedRegDate] = useState(
        cafDocData.registationDate ? new Date(cafDocData.registationDate) : null
    );
    const [selectedPhotoProofDate, setSelectedPhotoProofDate] = useState(
        cafDocData.photoProofdate ? new Date(cafDocData.photoProofdate) : null
    );
    const [selectedAuthDate, setSelectedAuthDate] = useState(
        cafDocData.authLetterDate ? new Date(cafDocData.authLetterDate) : null
    );
    const [selectedPoDate, setSelectedPoDate] = useState(
        cafDocData.poDate ? new Date(cafDocData.poDate) : null
    );
    const [selectedNetworkDate, setSelectedNetworkDate] = useState(
        cafDocData.networkDate ? new Date(cafDocData.networkDate) : null
    );
    const [selectedAddressProofDate, setSelectedAddressProofDate] = useState(
        cafDocData.addressProofdate ? new Date(cafDocData.addressProofdate) : null
    );

    const isWeekday = (date) => {
        // const day = date.getDay();
        // return day !== 0 && day !== 6; // Disable Saturdays and Sundays

        const today = new Date();
        let count = 0;
        let tempDate = new Date(today);
        const selectableDates = [];

        // Loop to get the next 5 valid weekdays (including today)
        while (count < 5) {
            const day = tempDate.getDay();
            if (day !== 0 && day !== 6) { // Skip Sundays (0) & Saturdays (6)
                selectableDates.push(new Date(tempDate)); // Store valid date
                count++;
            }
            tempDate.setDate(tempDate.getDate() + 1); // Move to next day
        }

        return selectableDates.some(
            (validDate) => validDate.toDateString() === date.toDateString()
        );
    };


    const handleDateChange = async (e, docName) => {
        // const selectedDate = e.target.value; // Get the selected date

        const inputDate = e.target.value; // Input date is in yyyy-MM-dd format
        const [year, month, day] = inputDate.split("-");
        // const formattedDate = `${year}-${day}-${month}`; // Convert to yyyy-dd-mm
        const formattedDate = `${year}-${month}-${day}`;


        setCafDocData((prevState) => ({
            ...prevState,
            [`${docName}Date`]: formattedDate,
        }));

        let documentName;
        switch (docName) {
            case "authorisationLetter":
                documentName = "Authorisation letter";
                break;
            case "gstNumber":
                documentName = "GST Number";
                break;
            case "panNumber":
                documentName = "Company PAN Number";
                break;
            case "deedNumber":
                documentName = "Trust Deed";
                break;
            case "tanNumber":
                documentName = "TAN Number";
                break;
            case "registationNumber":
                documentName = "Registation Certificate";
                break;
            case "coi":
                documentName = "COI";
                break;
            case "poi":
                documentName = "Poi";
                break;
            case "addressProof":
                documentName = "Address Proof";
                break;
            case "photoProof":
                documentName = "Photo Proof";
                break;
            case "po":
                documentName = "PO";
                break;
            case "pd":
                documentName = "PD";
                break;
            case "cafReport":
                documentName = "cafReport";
                break;
            case "networkDiagram":
                documentName = "Network Diagram";
                break;
        }

        try {
            const apiUrl = process.env.REACT_APP_API_URL_3;
            const apiPayload = {
                Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                Action: "uploadDocDigitalCaf",
                password: sessionStorage.getItem('password'),
                userName: sessionStorage.getItem('userName'),
                CafSafNo: cafSafNo,
            };
            let data = [
                {
                    DocumentName: documentName,
                    DocumentNumber: "",
                    PendingDocSubmitOn: `${formattedDate}`,
                    fileNameWithExtension: "",
                    fileContent: "",
                    IsGSTapplicable: "",
                    GSTDeclaration: ""
                },
            ];
            if (selectGst.label == "Yes") {
                // data[0]["IsGSTapplicable"] = selectGst.label;
                // data[0]["GSTDeclaration"] = "";
                data = [
                    {
                        DocumentName: documentName,
                        DocumentNumber: "",
                        PendingDocSubmitOn: `${formattedDate}`,
                        fileNameWithExtension: "",
                        fileContent: "",
                        IsGSTapplicable: docName == "gstNumber" ? selectGst.label : "",
                        GSTDeclaration: ""
                    },
                ];
            }

            apiPayload["data"] = data;
            const response = await fetch(apiUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(apiPayload),
            });
            const result = await response.json();
            // console.log("API Response:", result);
            if (result.Response.StatusCode == 200) {
                toast.success("Documents Submission Date Updated", {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                });
                // window.location.reload()
            }
            // Optionally update UI state based on response
        } catch (error) {
            console.error("Error calling API:", error);
        }


    };


    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                // console.log(searchParams.get("LeadId"));

                const apiUrl = process.env.REACT_APP_API_URL;
                const requestBody = {
                    Action: "getopportunity",
                    Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                    LeadId: "",
                    OppId: OppId || "",
                    password: sessionStorage.getItem('password'),
                    userName: sessionStorage.getItem('userName'),
                };
                const response = await fetch(apiUrl, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(requestBody),
                });
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                const response2 = await response.json();
                // console.log("responsedata: ", response2?.Response?.Data[0]);
                setopportunity(response2?.Response?.Data[0])
                // setFirmType(response2.Response.Data[0].Firmtype)

            } catch (error) {
                // Handle fetch error
                console.error("Error fetching data:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, []);



    const navigate = useNavigate();
    const redirectBroadbandCafformPage = () => {
        Swal.fire({
            html: '<div style="font-size: 15px;">Do you want to go back to the previous screen?</div>',
            showCancelButton: true,
            confirmButtonText:
                '<span style="font-size: 12px;color:rgb(148,101,170);">YES</span>',
            cancelButtonText:
                '<span style="font-size: 12px;color:rgb(148,101,170);">NO</span>',
            confirmButtonColor: "white",
            cancelButtonColor: "white",
            customClass: {
                popup: "custom-popup",
                confirmButton: "custom-confirm-button",
                cancelButton: "custom-cancel-button",
            },
        }).then((result) => {
            if (result.isConfirmed) {
                navigate(`/businessSafmanageForm?SafNo=${cafSafNo}&OppId=${OppId}`);
            } else {
                navigate(`/businessSafmanageForm`);
            }
        });
    };



    useEffect(() => {
        const fetchData = async () => {
            try {
                const apiUrl = process.env.REACT_APP_API_URL;
                const requestData = {
                    "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                    "Action": "getDocDigitalCafSaf",
                    "userName": sessionStorage.getItem('userName'),
                    "password": sessionStorage.getItem('password'),
                    "CafSafNo": cafSafNo
                };

                const response = await fetch(apiUrl, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(requestData),
                });
                const data = await response.json();
                // updateRequiredDoc(data);
                // Check if Response and data are available
                if (data?.Response?.data) {

                    const docs = data.Response.data;

                    // Create a map of document name to data
                    const documentMap = docs.reduce((acc, doc) => {
                        acc[doc.DocumentName] = doc;
                        return acc;
                    }, {});
                    // console.log("data.Response.CafSafNo", data.Response.CafSafNo)
                    // Set data dynamically using document names (like "COI", "PAN", etc.)
                    setCafDocData({
                        cafNo: data.Response.CafSafNo,
                        addressProofNum: documentMap["Address Proof"]?.DocumentNumber || "",
                        addressProofDoc: documentMap["Address Proof"]?.fileNameWithExtension || "",
                        addressDocRej: documentMap["Address Proof"]?.SubRejectReason || "",
                        photoProofNum: documentMap["Photo Proof"]?.DocumentNumber || "",
                        photoProofDoc: documentMap["Photo Proof"]?.fileNameWithExtension || "",
                        photoDocRej: documentMap["Photo Proof"]?.SubRejectReason || "",
                        authLetterNum: documentMap["Authorisation letter"]?.DocumentNumber || "",
                        authLetterDoc: documentMap["Authorisation letter"]?.fileNameWithExtension || "",
                        authDocRej: documentMap["Authorisation letter"]?.SubRejectReason || "",
                        coiNum: documentMap["COI"]?.DocumentNumber || "",
                        coiDoc: documentMap["COI"]?.fileNameWithExtension || "",
                        coiDocRej: documentMap["COI"]?.SubRejectReason || "",
                        purchaseNum: documentMap["PO"]?.DocumentNumber || "",
                        purchaseDoc: documentMap["PO"]?.fileNameWithExtension || "",
                        purchaseDocRej: documentMap["PO"]?.SubRejectReason || "",
                        partnerDeedNum: documentMap["PD"]?.DocumentNumber || "",
                        partnerDeedDoc: documentMap["PD"]?.fileNameWithExtension || "",
                        partnerDeedDocRej: documentMap["PD"]?.SubRejectReason || "",
                        cafReportNum: documentMap["CAF Report"]?.DocumentNumber || "",
                        cafReportDoc: documentMap["CAF Report"]?.fileNameWithExtension || "",
                        cafReportDocRej: documentMap["CAF Report"]?.SubRejectReason || "",
                        panNum: documentMap["Company PAN Number"]?.DocumentNumber || "",
                        panDoc: documentMap["Company PAN Number"]?.fileNameWithExtension || "",
                        panDocRej: documentMap["Company PAN Number"]?.SubRejectReason || "",
                        deedNum: documentMap["Trust Deed"]?.DocumentNumber || "",
                        deedDoc: documentMap["Trust Deed"]?.fileNameWithExtension || "",
                        deedDocRej: documentMap["Trust Deed"]?.SubRejectReason || "",
                        gstNum: documentMap["GST Number"]?.DocumentNumber || "",
                        gstDoc: documentMap["GST Number"]?.fileNameWithExtension || "",
                        gstDocRej: documentMap["GST Number"]?.SubRejectReason || "",
                        poiNum: documentMap["POI of Authorized Signatory"]?.DocumentNumber || "",
                        poiDoc: documentMap["POI of Authorized Signatory"]?.fileNameWithExtension || "",
                        poiDocRej: documentMap["POI of Authorized Signatory"]?.SubRejectReason || "",
                        tanNum: documentMap["TAN Number"]?.DocumentNumber || "",
                        tanDoc: documentMap["TAN Number"]?.fileNameWithExtension || "",
                        tanDocRej: documentMap["TAN Number"]?.SubRejectReason || "",
                        registationNum: documentMap["Registation Certificate"]?.DocumentNumber || "",
                        registationDoc: documentMap["Registation Certificate"]?.fileNameWithExtension || "",
                        registationDocRej: documentMap["Registation Certificate"]?.SubRejectReason || "",

                        poNum: documentMap["PO"]?.DocumentNumber || "",
                        poDoc: documentMap["PO"]?.fileNameWithExtension || "",
                        poDocRej: documentMap["PO"]?.SubRejectReason || "",

                        networkNum: documentMap["Network Diagram"]?.DocumentNumber || "",
                        networkDoc: documentMap["Network Diagram"]?.fileNameWithExtension || "",
                        networkDocRej: documentMap["Network Diagram"]?.SubRejectReason || "",

                    });

                    const parseValidDate = (dateString) => {
                        if (!dateString) return null; // Handle empty or undefined values
                        // console.log("Parsing Date:", dateString);
                        // Try direct parsing
                        let parsedDate = new Date(dateString);
                        if (!isNaN(parsedDate.getTime())) return parsedDate;
                        // Handle possible backend format variations
                        const dateParts = dateString.split(/[-/]/); // Supports "yyyy-mm-dd", "dd-mm-yyyy"
                        if (dateParts.length === 3) {
                            let [year, month, day] = dateParts.map(Number);
                            // If the year is not in the correct position, swap
                            if (year < 1000) [day, month, year] = [year, month, day];
                            parsedDate = new Date(year, month - 1, day);
                            if (!isNaN(parsedDate.getTime())) return parsedDate;
                        }
                        console.error("Invalid date format:", dateString);
                        return null; // Return null if date is still invalid
                    };
                    setSelectedCoiDate(parseValidDate(documentMap["COI"]?.DocumentSubmittedWithin));
                    setSelectedDeedDate(parseValidDate(documentMap["Trust Deed"]?.DocumentSubmittedWithin));
                    setSelectedPartnerDeedDate(parseValidDate(documentMap["PD"]?.DocumentSubmittedWithin));
                    setSelectedPanDate(parseValidDate(documentMap["Company PAN Number"]?.DocumentSubmittedWithin));
                    setSelectedGstDate(parseValidDate(documentMap["GST Number"]?.DocumentSubmittedWithin));
                    setSelectedTanDate(parseValidDate(documentMap["TAN Number"]?.DocumentSubmittedWithin));
                    setSelectedRegDate(parseValidDate(documentMap["Registation Certificate"]?.DocumentSubmittedWithin));
                    setSelectedPhotoProofDate(parseValidDate(documentMap["Photo Proof"]?.DocumentSubmittedWithin));
                    setSelectedAuthDate(parseValidDate(documentMap["Authorisation letter"]?.DocumentSubmittedWithin));
                    setSelectedAddressProofDate(parseValidDate(documentMap["Address Proof"]?.DocumentSubmittedWithin));
                    setSelectedPoDate(parseValidDate(documentMap["PO"]?.DocumentSubmittedWithin));
                    setSelectedNetworkDate(parseValidDate(documentMap["Network Diagram"]?.DocumentSubmittedWithin));
                    // Set verification statuses dynamically
                    setSelectGst({
                        value: documentMap["GST Number"]?.IsGSTapplicable,
                        label: documentMap["GST Number"]?.IsGSTapplicable,
                    });
                    // console.log("gggg", documentMap["GST Number"]?.IsGSTapplicable);

                    setAddressDocVerify(documentMap["Address Proof"]?.ApprovalStatus || "");
                    setPhotoDocVerify(documentMap["Photo Proof"]?.ApprovalStatus || "");
                    setAuthLetterDocVerify(documentMap["Authorisation letter"]?.ApprovalStatus || "");
                    setCoiDocVerify(documentMap["COI"]?.ApprovalStatus || "");
                    setPurchaseDocVerify(documentMap["PO"]?.ApprovalStatus || "")
                    setPartnerDeedDocVerify(documentMap["PD"]?.ApprovalStatus || "");
                    setCafReportDocVerify(documentMap["CAF Report"]?.ApprovalStatus || "")
                    setPanDocVerify(documentMap["Company PAN Number"]?.ApprovalStatus || "");
                    setDeedDocVerify(documentMap["Trust Deed"]?.ApprovalStatus || "");
                    setGstDocVerify(documentMap["GST Number"]?.ApprovalStatus || "");
                    setPoiDocVerify(documentMap["POI of Authorized Signatory"]?.ApprovalStatus || "");
                    setTanDocVerify(documentMap["TAN Number"]?.ApprovalStatus || "");
                    setRegistationDocVerify(documentMap["Registation Certificate"]?.ApprovalStatus || "");
                    setPoDocVerify(documentMap["PO"]?.ApprovalStatus || "");
                    setNetworkDocVerify(documentMap["Network Diagram"]?.ApprovalStatus || "");
                } else {
                    console.error("No document data found in the response.");
                }
            } catch (error) {
                console.error("Error fetching data:", error.message);
            }
        };

        fetchData();
    }, []);



    useEffect(() => {
        const fetchBussinessCAF = async () => {
            try {
                const apiUrl = process.env.REACT_APP_API_URL;

                const requestData = {
                    Action: "getDigitSaf",
                    Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                    safNo: cafSafNo,
                    password: sessionStorage.getItem("password"),
                    userName: sessionStorage.getItem("userName"),
                };
                const response = await fetch(apiUrl, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(requestData),
                });
                const result = await response.json();
                if (result.Status === "Success" && result.Response) {
                    // console.log("result.Response", result.Response);

                    setAutherName(result.Response.authorSigDetails.AuthName)
                    setFirmType(result.Response.documentRequired.FirmType)
                }

            } catch (error) {
                console.error("Error fetching data:", error.message);
            } finally {
                setLoading(false);
            }
        };

        fetchBussinessCAF();
    }, [cafSafNo]);





    const handleGenerateOTPforSel = async () => {
        try {
            const apiUrl = process.env.REACT_APP_API_URL_3;
            const requestData = {
                "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                "Action": "generateOTPforSel",
                "userName": sessionStorage.getItem('userName'),
                "password": sessionStorage.getItem('password'),
                "GenerateOTP": "Yes"
            }
            const response = await fetch(apiUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    // "token": "e7e916c2e449f6306b27dea2fb2dde46",
                },
                body: JSON.stringify(requestData),
            });
            const data = await response.json();
            // console.log("response", data);


        } catch (error) {
            console.error("Error fetching data:", error.message);
        }
    }

    const handleResendEmailToCust = async () => {
        try {
            const apiUrl = process.env.REACT_APP_API_URL_3;
            const requestData = {
                "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                "Action": "resendEmailToCust",
                "userName": sessionStorage.getItem('userName'),
                "password": sessionStorage.getItem('password'),
                "CafSafNo": cafSafNo,
                "ResendEmail": "Yes"
            }
            const response = await fetch(apiUrl, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    // "token": "e7e916c2e449f6306b27dea2fb2dde46",
                },
                body: JSON.stringify(requestData),
            });
            const data = await response.json();
            // console.log("response", data);


        } catch (error) {
            console.error("Error fetching data:", error.message);
        }
    }

    // const handleBlur = async (event) => {
    //     console.log("Input blurred with value:", event.target.value);
    //     // alert("hjhjgs");
    //     try {
    //         const apiUrl = process.env.REACT_APP_API_URL;
    //         const requestPayload = {
    //             "Action": "getCompanyGroupByPAN",
    //             "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
    //             "panNumber": event.target.value,
    //             "customerName": "",
    //             "userName": sessionStorage.getItem('userName'),
    //             "password": sessionStorage.getItem('password')
    //         };
    //         const response = await fetch(apiUrl, {
    //             method: "POST",
    //             headers: {
    //                 "Content-Type": "application/json",
    //             },
    //             body: JSON.stringify(requestPayload),
    //         });

    //         const result = await response.json();
    //         console.log("API Response:", result);
    //         // console.log("result.Response.Company",result.Response.Company);

    //         setPanCompany(result.Response.Company);
    //         setPanCompanyId(result.Response.CompanyID);
    //         setPanGroup(result.Response.Group);
    //         setPanGroupId(result.Response.GroupID);
    //         if (result.Response.StatusCode == 200) {
    //             Swal.fire({
    //                 text: "Company and Group hierarchy exists in CRM, Continue?",
    //                 confirmButtonText:
    //                     '<span style="font-size: 15px;">OK</span>',
    //                 confirmButtonColor: "rgb(148,101,170)",
    //             }).then(async (result) => {
    //                 if (result.isConfirmed) {
    //                     try {
    //                         const apiUrl = process.env.REACT_APP_API_URL;
    //                         const requestPayload = {
    //                             "Action": "updateCompRelGroup",
    //                             "Authkey": "ac7b51de9d888e1458dd53d8aJAN3ba6f",
    //                             "CafNo": cafSafNo,
    //                             "Company": panCompany ? panCompany : "",
    //                             "CompanyID": panCompanyId ? panCompanyId : "",
    //                             "Group": panGroup ? panGroup : "",
    //                             "GroupID": panGroupId ? panGroupId : "",
    //                             "userName": sessionStorage.getItem('userName'),
    //                             "password": sessionStorage.getItem('password')
    //                         }
    //                         const response = await fetch(apiUrl, {
    //                             method: "POST",
    //                             headers: {
    //                                 "Content-Type": "application/json",
    //                             },
    //                             body: JSON.stringify(requestPayload),
    //                         });
    //                         console.log("panCompany", panCompany);

    //                         const result = await response.json();
    //                         console.log("API Response:", result);
    //                         if (result.Response.StatusCode == "200") {
    //                             toast.success(result.Response.Message, {
    //                                 position: toast.POSITION.BOTTOM_CENTER,
    //                                 autoClose: 1500,
    //                             });
    //                         }
    //                     } catch (error) {
    //                         console.error("Error in handleGstDeclaration API:", error);
    //                     }
    //                 }
    //             })
    //         }
    //         else {
    //             toast.warning(result.Response.Message, {
    //                 position: toast.POSITION.BOTTOM_CENTER,
    //                 autoClose: 2000,
    //             });
    //         }


    //     } catch (error) {
    //         console.error("Error in handleGstDeclaration API:", error);
    //     }
    // };

    return (
        <>
            {/* ***********Header********* */}
            <div className="container-fluid text-light Header-style header">
                <div className="p-3">
                    <span
                        className=""
                        style={{ cursor: "pointer" }}
                        onClick={redirectBroadbandCafformPage}
                    >
                        <i className="fa-solid fa-arrow-left-long"></i>
                    </span>
                    <span className="p-1 m-3">Business SAF</span>
                </div>
            </div>
            {/* ***********Header END********* */}

            <div>
                {loading ? (
                    <div className="loader-wrapper">
                        <div className="loader">
                            <img src={load} alt="loading...."></img>
                        </div>
                    </div>
                ) : (
                    <div
                        className=" container shadow mb-3 bg-body rounded form-container"
                        id="form8">
                        <form className="contact-form p-2">
                            <div className="input-box form-floating p-1">
                                <input
                                    type="text"
                                    placeholder=""
                                    className=" form-control input-text form-control-sm "
                                    id="fullName"
                                    name="fullName"
                                    // value={cafDocData.cafNo}
                                    value={cafSafNo}
                                />
                                <i
                                    className="fa-solid fa-lock text-secondary"
                                    style={{
                                        position: "absolute",
                                        right: "20px",
                                        top: "60%",
                                        transform: "translateY(-50%)",
                                    }}
                                ></i>
                                <label htmlFor="floatingInput" className="lock m-1">
                                    SAF No.*
                                </label>
                            </div>
                            {/* {console.log("cafDocData.cafNo", cafDocData.cafNo)} */}




                            <div className="">
                                <label className="select-search-label mt-1">Is GST applicable?</label>
                                <Select
                                    className=" basic-single form-control form-control-sm p-1"
                                    classNamePrefix="select"
                                    id="floatingSelect"
                                    aria-label="Floating label select example"
                                    name="dnc"
                                    styles={style}
                                    placeholder="Select Option"
                                    value={selectGst}
                                    onChange={handleIsGst}
                                    options={GstOpts.map((data) => ({
                                        value: data.value,
                                        label: data.label,
                                    }))}
                                />
                            </div>


                            {selectGst.label == "No" &&
                                <div className="">
                                    <label className="select-search-label mt-1">Declaration</label>
                                    <Select
                                        className=" basic-single form-control form-control-sm p-1"
                                        classNamePrefix="select"
                                        id="floatingSelect"
                                        aria-label="Floating label select example"
                                        name="dnc"
                                        styles={style}
                                        placeholder="Select Option"
                                        value={selectDec}
                                        onChange={handleGstDeclaration}
                                        options={DecOpts.map((data) => ({
                                            value: data.value,
                                            label: data.label,
                                        }))}
                                    />
                                </div>
                            }


                            {/* Caf Report new*/}

                            {/* <div className="border doc-styling">
                                <div className="input-box form-floating">
                                    <input
                                        type="text"
                                        placeholder="Enter COI Number"
                                        className="form-control input-text form-control-sm"
                                        name="coiNum"
                                        value={cafDocData?.cafReportNum || ""}
                                        disabled={cafReportDocVerify === "Verified"}
                                        onChange={handleChange}
                                    />
                                    <label htmlFor="gstNumber">CAF Report</label>
                                    {cafReportDocVerify !== "Verified" && (
                                        <>
                                            <div className="form-check form-check-style">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    value="cafReportCheck"
                                                    name="cafReportCheck"
                                                    id="cafReportCheck"
                                                    checked={isCheckboxChecked.cafReportCheck}
                                                    onChange={handleCheckboxChange}
                                                />
                                                <label
                                                    className="form-check-label"
                                                    htmlFor="cafReportCheck"
                                                >
                                                    If the document is not available. Please click on the checkbox.
                                                </label>
                                            </div>

                                            {isCheckboxChecked.cafReportCheck ? (
                                                <div className="input-box form-floating">
                                                    <input
                                                        type="date"
                                                        className="form-control input-text form-control-sm"
                                                        id="docDate"
                                                        name="cafReportDate"
                                                        value={cafDocData.cafReportDate || ""}
                                                        onChange={(e) => handleDateChange(e, "cafReport")}
                                                    />
                                                    <label htmlFor="docDate" className="p-2">
                                                       Expected Document Date
                                                    </label>
                                                </div>
                                            ) : (
                                                <div
                                                    className="input-box form-floating mt-3"
                                                    style={{ position: "relative" }}
                                                >
                                                    <input
                                                        id="cafReportUpload"
                                                        type="file"
                                                        accept="image/*,application/pdf"
                                                        onChange={(e) => handleFileUpload(e, "cafReport")}
                                                        style={{ display: "none" }}
                                                    />
                                                    <input
                                                        type="text"
                                                        placeholder=""
                                                        className="form-control input-text form-control-sm mt-1"
                                                        id="cafReportText"
                                                        value={uploadedCafFile || ""}
                                                        readOnly
                                                        onClick={() =>
                                                            document.getElementById("cafReportUpload").click()
                                                        }
                                                    />
                                                    <i
                                                        className="fa-solid fa-paperclip fa-paper-icon fa-locator"
                                                        onClick={() =>
                                                            document.getElementById("cafReportUpload").click()
                                                        }
                                                    ></i>
                                                    <label htmlFor="cafReportText" className="paperclip mt-2">
                                                        CAF Report*
                                                    </label>
                                                </div>
                                            )}
                                        </>
                                    )}
                                </div>

                              
                                <div className="input-box form-floating">
                                    <div className="p-3 d-flex flex-column flex-sm-row doc-rej">
                                        <span className="mb-2 mb-sm-0">{cafDocData.cafReportDoc}</span>
                                        &nbsp;
                                        <span className="mb-sm-0 doc-rej-color">
                                            {cafDocData.cafReportDocRej
                                                ? `(${cafDocData.cafReportDocRej})`
                                                : ""}
                                        </span>
                                    </div>

                                    {cafReportDocVerify && (
                                        <>
                                            {cafReportDocVerify === "Verified" ? (
                                                <i
                                                    className="fa-solid fa-check"
                                                    style={{
                                                        position: "absolute",
                                                        right: "20px",
                                                        top: "70%",
                                                        transform: "translateY(-50%)",
                                                        color: "#77c171",
                                                    }}
                                                ></i>
                                            ) : (
                                                <i
                                                    className="fa-solid fa-xmark"
                                                    style={{
                                                        position: "absolute",
                                                        right: "20px",
                                                        top: "70%",
                                                        transform: "translateY(-50%)",
                                                        color: "#f20d24",
                                                    }}
                                                ></i>
                                            )}
                                        </>
                                    )}
                                </div>
                            </div> */}


                            {/* COI Number */}
                          
                                <div className="border doc-styling">
                                    <div className="input-box form-floating">
                                        <input
                                            type="text"
                                            placeholder="Enter COI Number"
                                            className="form-control input-text form-control-sm"
                                            name="coiNum"
                                            value={cafDocData?.coiNum}
                                            disabled={coiDocVerify === "Verified"}
                                            onChange={handleChange}
                                        />
                                        <label htmlFor="coiNumber">COI</label>

                                        {coiDocVerify !== "Verified" && (
                                            <>
                                                <div className="form-check form-check-style">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        value="coiCheck"
                                                        name="coiCheck"
                                                        id="coiCheck"
                                                        checked={isCheckboxChecked.coiCheck}
                                                        onChange={handleCheckboxChange}
                                                    />
                                                    <label className="form-check-label" htmlFor="coiCheck">
                                                        If the document is not available. Please click on the checkbox.
                                                    </label>
                                                </div>

                                                {(isCheckboxChecked.coiCheck || selectedCoiDate) ? (
                                                    <>
                                                        <div className='date-div'>
                                                            <label htmlFor="partnerDeedDate" className="date-label-div">
                                                            Expected Document Date
                                                            </label>
                                                        </div>
                                                        <div className="input-box form-floating d-flex align-items-center position-relative"
                                                            style={{
                                                                borderBottom: "1px solid #dee0de",
                                                                width: "100%",
                                                                // maxWidth: "1500px", // Adjust as needed
                                                            }}>
                                                            <DatePicker
                                                                selected={selectedCoiDate}
                                                                onChange={(date) => {
                                                                    setSelectedCoiDate(date);
                                                                    handleDateChange(
                                                                        { target: { value: date.toISOString().split("T")[0] } },
                                                                        "coi"
                                                                    );
                                                                }}
                                                                filterDate={isWeekday}
                                                                dateFormat="dd-MM-yyyy"
                                                                placeholderText="Select Date"
                                                                className="form-control input-text form-control-sm p-2"
                                                                style={{
                                                                    width: "100%",
                                                                    paddingRight: "40px", // Ensure space for icon
                                                                    maxWidth: "1500px",
                                                                }}
                                                            />
                                                            <i
                                                                className="fa-solid fa-calendar-days position-absolute"
                                                                style={{
                                                                    right: "20px",
                                                                    top: "50%",
                                                                    transform: "translateY(-50%)",
                                                                    color: "#8b8c8b",
                                                                }}
                                                            ></i>
                                                        </div>
                                                    </>
                                                ) : null}
                                                {(selectedCoiDate || coiDocVerify !== "Verified") && (
                                                    <div
                                                        className="input-box form-floating mt-3"
                                                        style={{ position: "relative" }}
                                                    >
                                                        <input
                                                            id="coiUpload"
                                                            type="file"
                                                            accept="image/*,application/pdf"
                                                            onChange={(e) => handleFileUpload(e, "coi")}
                                                            style={{ display: "none" }}
                                                        />
                                                        <input
                                                            type="text"
                                                            placeholder=""
                                                            className="form-control input-text form-control-sm mt-1"
                                                            id="coiFileName"
                                                            value={uploadedCoiFile}
                                                            readOnly
                                                            onClick={() => document.getElementById("coiUpload").click()}
                                                        />
                                                        <i
                                                            className="fa-solid fa-paperclip fa-paper-icon fa-locator"
                                                            onClick={() => document.getElementById("coiUpload").click()}
                                                        ></i>
                                                        <label htmlFor="coiFileName" className="paperclip mt-2">
                                                            COI Document*
                                                        </label>
                                                    </div>
                                                )}

                                                {(!uploadedCoiFile && coiDocVerify !== "Verified" && autherName && (firmType == "3" || firmType == "4")) &&
                                                    <div className="req-color">&nbsp;Required Field*</div>}
                                            </>
                                        )}
                                    </div>

                                    {/* COI Document Verification Status */}
                                    <div className="input-box form-floating">
                                        <div className="p-3 d-flex flex-column flex-sm-row doc-rej">
                                            <span className="mb-2 mb-sm-0">{cafDocData?.coiDoc}</span>&nbsp;
                                            <span className="mb-sm-0 doc-rej-color">
                                                {cafDocData?.coiDocRej ? `(${cafDocData.coiDocRej})` : ""}
                                            </span>
                                        </div>

                                        {coiDocVerify && (
                                            <>
                                                {coiDocVerify === "Verified" ? (
                                                    <i
                                                        className="fa-solid fa-check"
                                                        style={{
                                                            position: "absolute",
                                                            right: "20px",
                                                            top: "70%",
                                                            transform: "translateY(-50%)",
                                                            color: "#77c171",
                                                        }}
                                                    ></i>
                                                ) : (
                                                    <i
                                                        className="fa-solid fa-xmark"
                                                        style={{
                                                            position: "absolute",
                                                            right: "20px",
                                                            top: "70%",
                                                            transform: "translateY(-50%)",
                                                            color: "#f20d24",
                                                        }}
                                                    ></i>
                                                )}
                                            </>
                                        )}
                                    </div>
                                </div>

                            {/* Trust Deed */}
                            {firmType == "5" &&
                                <div className="border mt-2 doc-styling">
                                    <div className="input-box form-floating">
                                        <input
                                            type="text"
                                            placeholder="Enter Deed Number"
                                            className="form-control input-text form-control-sm"
                                            name="deedNum"
                                            value={cafDocData?.deedNum}
                                            disabled={deedDocVerify === "Verified"}
                                            onChange={handleChange}
                                        />
                                        <label htmlFor="deedNumber">Trust Deed</label>

                                        {deedDocVerify !== "Verified" && (
                                            <>
                                                {firmType !== "5" &&
                                                    <div className="form-check form-check-style">
                                                        <input
                                                            className="form-check-input"
                                                            type="checkbox"
                                                            value="deedCheck"
                                                            name="deedCheck"
                                                            id="deedCheck"
                                                            checked={isCheckboxChecked.deedCheck}
                                                            onChange={handleCheckboxChange}
                                                        />
                                                        <label className="form-check-label" htmlFor="panCheck">
                                                            If the document is not available. Please click on the checkbox.
                                                        </label>
                                                    </div>}

                                                {(isCheckboxChecked.deedCheck || selectedDeedDate) ? (
                                                    <>
                                                        <div className='date-div'>
                                                            <label htmlFor="partnerDeedDate" className="date-label-div">
                                                            Expected Document Date
                                                            </label>
                                                        </div>
                                                        <div className="input-box form-floating d-flex align-items-center position-relative"
                                                            style={{
                                                                borderBottom: "1px solid #dee0de",
                                                                width: "100%",
                                                                // maxWidth: "1500px", // Adjust as needed
                                                            }}>
                                                            <DatePicker
                                                                selected={selectedDeedDate}
                                                                onChange={(date) => {
                                                                    setSelectedDeedDate(date);
                                                                    handleDateChange(
                                                                        { target: { value: date.toISOString().split("T")[0] } },
                                                                        "deedNumber"
                                                                    );
                                                                }}
                                                                filterDate={isWeekday}
                                                                dateFormat="dd-MM-yyyy"
                                                                placeholderText="Select Date"
                                                                className="form-control input-text form-control-sm p-2"
                                                                style={{
                                                                    width: "100%",
                                                                    paddingRight: "40px", // Ensure space for icon
                                                                    maxWidth: "1500px",
                                                                }}
                                                            />
                                                            <i
                                                                className="fa-solid fa-calendar-days position-absolute"
                                                                style={{
                                                                    right: "20px",
                                                                    top: "50%",
                                                                    transform: "translateY(-50%)",
                                                                    color: "#8b8c8b",
                                                                }}
                                                            ></i>
                                                        </div>
                                                    </>
                                                ) : null}
                                                {(selectedDeedDate || deedDocVerify !== "Verified") && (
                                                    <div
                                                        className="input-box form-floating mt-3"
                                                        style={{ position: "relative" }}
                                                    >
                                                        <input
                                                            id="deedUpload"
                                                            type="file"
                                                            accept="image/*,application/pdf"
                                                            onChange={(e) => handleFileUpload(e, "deedNumber")}
                                                            style={{ display: "none" }}
                                                        />
                                                        <input
                                                            type="text"
                                                            placeholder=""
                                                            className="form-control input-text form-control-sm mt-1"
                                                            id="deedFileName"
                                                            value={uploadedDeedFile}
                                                            readOnly
                                                            onClick={() => document.getElementById("deedUpload").click()}
                                                        />
                                                        <i
                                                            className="fa-solid fa-paperclip fa-paper-icon fa-locator"
                                                            onClick={() => document.getElementById("deedUpload").click()}
                                                        ></i>
                                                        <label htmlFor="deedFileName" className="paperclip mt-2">
                                                            Trust Deed
                                                        </label>
                                                    </div>
                                                )}

                                                {(!uploadedDeedFile && deedDocVerify !== "Verified") &&
                                                    <div className="req-color">&nbsp;Required Field**</div>}
                                            </>
                                        )}
                                    </div>

                                    {/* DEED Document Verification Status */}
                                    <div className="input-box form-floating">
                                        <div className="p-3 d-flex flex-column flex-sm-row doc-rej">
                                            <span className="mb-2 mb-sm-0">{cafDocData?.deedDoc}</span>&nbsp;
                                            <span className="mb-sm-0 doc-rej-color">
                                                {cafDocData?.deedDocRej ? `(${cafDocData.deedDocRej})` : ""}
                                            </span>
                                        </div>

                                        {deedDocVerify && (
                                            <>
                                                {panDocVerify === "Verified" ? (
                                                    <i
                                                        className="fa-solid fa-check"
                                                        style={{
                                                            position: "absolute",
                                                            right: "20px",
                                                            top: "70%",
                                                            transform: "translateY(-50%)",
                                                            color: "#77c171",
                                                        }}
                                                    ></i>
                                                ) : (
                                                    <i
                                                        className="fa-solid fa-xmark"
                                                        style={{
                                                            position: "absolute",
                                                            right: "20px",
                                                            top: "70%",
                                                            transform: "translateY(-50%)",
                                                            color: "#f20d24",
                                                        }}
                                                    ></i>
                                                )}
                                            </>
                                        )}
                                    </div>
                                </div>}

                            {/* Partnership Deed */}
                            {(firmType == "2" || firmType == '3' || firmType == '4') &&
                                <div className="border doc-styling">
                                    <div className="input-box form-floating">
                                        <input
                                            type="text"
                                            placeholder="Enter Purchase Order Number"
                                            className="form-control input-text form-control-sm"
                                            name="partnerDeedNum"
                                            value={cafDocData?.partnerDeedNum}
                                            disabled={partnerDeedDocVerify === "Verified"}
                                            onChange={handleChange}
                                        />
                                        <label htmlFor="partnerDeedNum">Partnership Deed</label>

                                        {partnerDeedDocVerify !== "Verified" && (
                                            <>
                                                {/* Checkbox to indicate document unavailability */}
                                                <div className="form-check form-check-style">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        value="partnerDeedCheck"
                                                        name="partnerDeedCheck"
                                                        id="partnerDeedCheck"
                                                        checked={isCheckboxChecked.partnerDeedCheck}
                                                        onChange={handleCheckboxChange}
                                                    />
                                                    <label
                                                        className="form-check-label"
                                                        htmlFor="partnerDeedCheck"
                                                    >
                                                        If the document is not available. Please click on the checkbox.
                                                    </label>
                                                </div>

                                                {/* Conditional fields for file upload or date input */}
                                                {(isCheckboxChecked.partnerDeedCheck || selectedPartnerDeedDate) ? (
                                                    <>
                                                        <div className='date-div'>
                                                            <label htmlFor="partnerDeedDate" className="date-label-div">
                                                            Expected Document Date
                                                            </label>
                                                        </div>
                                                        <div className="input-box form-floating d-flex align-items-center position-relative"
                                                            style={{
                                                                borderBottom: "1px solid #dee0de",
                                                                width: "100%",
                                                                // maxWidth: "1500px", // Adjust as needed
                                                            }}>

                                                            <DatePicker
                                                                selected={selectedPartnerDeedDate}
                                                                onChange={(date) => {
                                                                    setSelectedPartnerDeedDate(date);
                                                                    handleDateChange(
                                                                        { target: { value: date.toISOString().split("T")[0] } },
                                                                        "pd"
                                                                    );
                                                                }}
                                                                filterDate={isWeekday}
                                                                dateFormat="dd-MM-yyyy"
                                                                placeholderText="Select Date"
                                                                className="form-control input-text form-control-sm p-2"
                                                                style={{
                                                                    width: "100%",
                                                                    paddingRight: "40px", // Ensure space for icon
                                                                    maxWidth: "1500px",
                                                                }}
                                                            />

                                                            <i
                                                                className="fa-solid fa-calendar-days position-absolute"
                                                                style={{
                                                                    right: "20px",
                                                                    top: "50%",
                                                                    transform: "translateY(-50%)",
                                                                    color: "#8b8c8b",
                                                                }}
                                                            ></i>
                                                        </div>
                                                    </>
                                                ) : null}
                                                {(selectedPartnerDeedDate || partnerDeedDocVerify !== "Verified") && (
                                                    <div
                                                        className="input-box form-floating mt-3"
                                                        style={{ position: "relative" }}
                                                    >
                                                        <input
                                                            id="partnerDeedUpload"
                                                            type="file"
                                                            accept="image/*,application/pdf"
                                                            onChange={(e) => handleFileUpload(e, "pd")}
                                                            style={{ display: "none" }}
                                                        />
                                                        <input
                                                            type="text"
                                                            placeholder=""
                                                            className="form-control input-text form-control-sm mt-1"
                                                            value={uploadedpartnerDeedFile || ""}
                                                            readOnly
                                                            onClick={() =>
                                                                document.getElementById("partnerDeedUpload").click()
                                                            }
                                                        />
                                                        <i
                                                            className="fa-solid fa-paperclip fa-paper-icon fa-locator"
                                                            onClick={() =>
                                                                document.getElementById("partnerDeedUpload").click()
                                                            }
                                                        ></i>
                                                        <label htmlFor="partnerDeedUpload" className="paperclip mt-2">
                                                            Partnership Deed*
                                                        </label>
                                                    </div>
                                                )}
                                            </>
                                        )}
                                    </div>

                                    {/* partnerDeed Order Verification Status */}
                                    <div className="input-box form-floating">
                                        <div className="p-3 d-flex flex-column flex-sm-row doc-rej">
                                            <span className="mb-2 mb-sm-0">{cafDocData.partnerDeedDoc}</span>&nbsp;
                                            <span className="mb-sm-0 doc-rej-color">
                                                {cafDocData.partnerDeedDocRej
                                                    ? `(${cafDocData.partnerDeedDocRej})`
                                                    : ""}
                                            </span>
                                        </div>

                                        {partnerDeedDocVerify && (
                                            <>
                                                {partnerDeedDocVerify === "Verified" ? (
                                                    <i
                                                        className="fa-solid fa-check"
                                                        style={{
                                                            position: "absolute",
                                                            right: "20px",
                                                            top: "70%",
                                                            transform: "translateY(-50%)",
                                                            color: "#77c171",
                                                        }}
                                                    ></i>
                                                ) : (
                                                    <i
                                                        className="fa-solid fa-xmark"
                                                        style={{
                                                            position: "absolute",
                                                            right: "20px",
                                                            top: "70%",
                                                            transform: "translateY(-50%)",
                                                            color: "#f20d24",
                                                        }}
                                                    ></i>
                                                )}
                                            </>
                                        )}
                                    </div>
                                </div>}

                            {/* PAN Number */}
                            <div className="border mt-2 doc-styling">
                                <div className="input-box form-floating">
                                    <input
                                        type="text"
                                        placeholder="Enter PAN Number"
                                        className="form-control input-text form-control-sm"
                                        name="panNum"
                                        value={cafDocData?.panNum}
                                        disabled={panDocVerify === "Verified"}
                                        onChange={handleChange}
                                    // onBlur={handleBlur}
                                    />
                                    <label htmlFor="panNumber">Company PAN</label>

                                    {panDocVerify !== "Verified" && (
                                        <>
                                            {/* <div className="form-check form-check-style">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    value="panCheck"
                                                    name="panCheck"
                                                    id="panCheck"
                                                    checked={isCheckboxChecked.panCheck}
                                                    onChange={handleCheckboxChange}
                                                />
                                                <label className="form-check-label" htmlFor="panCheck">
                                                    If the document is not available. Please click on the checkbox.
                                                </label>
                                            </div> */}

                                            {(isCheckboxChecked.panCheck || selectedPanDate) ? (
                                                <>
                                                    <div className='date-div'>
                                                        <label htmlFor="partnerDeedDate" className="date-label-div">
                                                        Expected Document Date
                                                        </label>
                                                    </div>
                                                    <div className="input-box form-floating d-flex align-items-center position-relative"
                                                        style={{
                                                            borderBottom: "1px solid #dee0de",
                                                            width: "100%",
                                                            // maxWidth: "1500px", // Adjust as needed
                                                        }}>
                                                        <DatePicker
                                                            selected={selectedPanDate}
                                                            onChange={(date) => {
                                                                setSelectedPanDate(date);
                                                                handleDateChange(
                                                                    { target: { value: date.toISOString().split("T")[0] } },
                                                                    "panNumber"
                                                                );
                                                            }}
                                                            filterDate={isWeekday}
                                                            dateFormat="dd-MM-yyyy"
                                                            placeholderText="Select Date"
                                                            className="form-control input-text form-control-sm p-2"
                                                            style={{
                                                                width: "100%",
                                                                paddingRight: "40px", // Ensure space for icon
                                                                maxWidth: "1500px",
                                                            }}
                                                        />
                                                        <i
                                                            className="fa-solid fa-calendar-days position-absolute"
                                                            style={{
                                                                right: "20px",
                                                                top: "50%",
                                                                transform: "translateY(-50%)",
                                                                color: "#8b8c8b",
                                                            }}
                                                        ></i>
                                                    </div>
                                                </>
                                            ) : null}
                                            {(selectedPanDate || panDocVerify !== "Verified") && (
                                                <div
                                                    className="input-box form-floating mt-3"
                                                    style={{ position: "relative" }}
                                                >
                                                    <input
                                                        id="panUpload"
                                                        type="file"
                                                        accept="image/*,application/pdf"
                                                        onChange={(e) => handleFileUpload(e, "panNumber")}
                                                        style={{ display: "none" }}
                                                    />
                                                    <input
                                                        type="text"
                                                        placeholder=""
                                                        className="form-control input-text form-control-sm mt-1"
                                                        id="panFileName"
                                                        value={uploadedPanFile || ""}
                                                        readOnly
                                                        onClick={() => document.getElementById("panUpload").click()}
                                                    />
                                                    <i
                                                        className="fa-solid fa-paperclip fa-paper-icon fa-locator"
                                                        onClick={() => document.getElementById("panUpload").click()}
                                                    ></i>
                                                    <label htmlFor="panFileName" className="paperclip mt-2">
                                                        PAN Document*
                                                    </label>
                                                </div>
                                            )}
                                        </>
                                    )}

                                    {(!uploadedPanFile && panDocVerify !== "Verified") &&
                                        <div className="req-color">&nbsp;Required Field*</div>}
                                </div>

                                {/* PAN Document Verification Status */}
                                <div className="input-box form-floating">
                                    <div className="p-3 d-flex flex-column flex-sm-row doc-rej">
                                        <span className="mb-2 mb-sm-0">{cafDocData?.panDoc}</span>&nbsp;
                                        <span className="mb-sm-0 doc-rej-color">
                                            {cafDocData?.panDocRej ? `(${cafDocData.panDocRej})` : ""}
                                        </span>
                                    </div>

                                    {panDocVerify && (
                                        <>
                                            {panDocVerify === "Verified" ? (
                                                <i
                                                    className="fa-solid fa-check"
                                                    style={{
                                                        position: "absolute",
                                                        right: "20px",
                                                        top: "70%",
                                                        transform: "translateY(-50%)",
                                                        color: "#77c171",
                                                    }}
                                                ></i>
                                            ) : (
                                                <i
                                                    className="fa-solid fa-xmark"
                                                    style={{
                                                        position: "absolute",
                                                        right: "20px",
                                                        top: "70%",
                                                        transform: "translateY(-50%)",
                                                        color: "#f20d24",
                                                    }}
                                                ></i>
                                            )}
                                        </>
                                    )}
                                </div>
                            </div>


                            {/* GST */}
                            {/* firmType == "1" || firmType == "2" || firmType == "3" || firmType == "4" || firmType == "5" */}
                            {selectGst.label == "Yes" && (firmType == "1" || firmType == "2" || firmType == "3" || firmType == "4" || firmType == "5") && (
                                <div className="border doc-styling">
                                    <div className="input-box form-floating">
                                        <input
                                            type="text"
                                            placeholder="Enter GST Number"
                                            className="form-control input-text form-control-sm"
                                            name="gstNum"
                                            value={cafDocData?.gstNum}
                                            disabled={gstDocVerify === "Verified"}
                                            onChange={handleChange}
                                        />
                                        <label htmlFor="gstNumber">GST Number</label>
                                        {gstDocVerify !== "Verified" && (
                                            <>
                                                {firmType == "5" &&
                                                    <div className="form-check form-check-style">
                                                        <input
                                                            className="form-check-input"
                                                            type="checkbox"
                                                            value="gstCheck"
                                                            name="gstCheck"
                                                            id="gstCheck"
                                                            checked={isCheckboxChecked.gstCheck}
                                                            onChange={handleCheckboxChange}
                                                        />
                                                        <label className="form-check-label" htmlFor="gstCheck">
                                                            If the document is not available. Please click on the checkbox.
                                                        </label>
                                                    </div>}

                                                {(isCheckboxChecked.gstCheck || selectedGstDate) ? (
                                                    <>
                                                        <div className='date-div'>
                                                            <label htmlFor="partnerDeedDate" className="date-label-div">
                                                            Expected Document Date
                                                            </label>
                                                        </div>
                                                        <div className="input-box form-floating d-flex align-items-center position-relative"
                                                            style={{
                                                                borderBottom: "1px solid #dee0de",
                                                                width: "100%",
                                                                // maxWidth: "1500px", // Adjust as needed
                                                            }}>
                                                            <DatePicker
                                                                selected={selectedGstDate}
                                                                onChange={(date) => {
                                                                    setSelectedGstDate(date);
                                                                    handleDateChange(
                                                                        { target: { value: date.toISOString().split("T")[0] } },
                                                                        "gstNumber"
                                                                    );
                                                                }}
                                                                filterDate={isWeekday}
                                                                dateFormat="dd-MM-yyyy"
                                                                placeholderText="Select Date"
                                                                className="form-control input-text form-control-sm p-2"
                                                                style={{
                                                                    width: "100%",
                                                                    paddingRight: "40px", // Ensure space for icon
                                                                    maxWidth: "1500px",
                                                                }}
                                                            />
                                                            <i
                                                                className="fa-solid fa-calendar-days position-absolute"
                                                                style={{
                                                                    right: "20px",
                                                                    top: "50%",
                                                                    transform: "translateY(-50%)",
                                                                    color: "#8b8c8b",
                                                                }}
                                                            ></i>
                                                        </div>
                                                    </>
                                                ) : null}
                                                {(selectedGstDate || gstDocVerify !== "Verified") && (
                                                    <div
                                                        className="input-box form-floating mt-3"
                                                        style={{ position: "relative" }}
                                                    >
                                                        <input
                                                            id="gstUpload"
                                                            type="file"
                                                            accept="image/*,application/pdf"
                                                            onChange={(e) => handleFileUpload(e, "gstNumber")}
                                                            style={{ display: "none" }}
                                                        />
                                                        <input
                                                            type="text"
                                                            placeholder=""
                                                            className="form-control input-text form-control-sm mt-1"
                                                            id="gstFileName"
                                                            value={uploadedGstFile}
                                                            readOnly
                                                            onClick={() =>
                                                                document.getElementById("gstUpload").click()
                                                            }
                                                        />
                                                        {/* {console.log('uploadedGstFile',uploadedGstFile)} */}
                                                        <i
                                                            className="fa-solid fa-paperclip fa-paper-icon fa-locator"
                                                            onClick={() =>
                                                                document.getElementById("gstUpload").click()
                                                            }
                                                        ></i>
                                                        <label htmlFor="gstFileName" className="paperclip mt-2">
                                                            GST Document*
                                                        </label>
                                                    </div>
                                                )}
                                            </>
                                        )}

                                        {(!uploadedGstFile && gstDocVerify !== "Verified" && firmType !== "5") &&
                                            <div className='req-color'>&nbsp;Required Field*</div>}

                                    </div>

                                    {/* GST Document Verification Status */}
                                    <div className="input-box form-floating">
                                        <div className="p-3 d-flex flex-column flex-sm-row doc-rej">
                                            <span className="mb-2 mb-sm-0">{cafDocData?.gstDoc}</span>
                                            &nbsp;
                                            <span className="mb-sm-0 doc-rej-color">
                                                {cafDocData?.gstDocRej ? `(${cafDocData.gstDocRej})` : ""}
                                            </span>
                                        </div>

                                        {gstDocVerify && (
                                            <>
                                                {gstDocVerify === "Verified" ? (
                                                    <i
                                                        className="fa-solid fa-check"
                                                        style={{
                                                            position: "absolute",
                                                            right: "20px",
                                                            top: "70%",
                                                            transform: "translateY(-50%)",
                                                            color: "#77c171",
                                                        }}
                                                    ></i>
                                                ) : (
                                                    <i
                                                        className="fa-solid fa-xmark"
                                                        style={{
                                                            position: "absolute",
                                                            right: "20px",
                                                            top: "70%",
                                                            transform: "translateY(-50%)",
                                                            color: "#f20d24",
                                                        }}
                                                    ></i>
                                                )}
                                            </>
                                        )}
                                    </div>
                                </div>
                            )}


                            {/* TAN */}
                            {(firmType == "1" || firmType == "2" || firmType == "3" || firmType == "4") &&
                                <div className="border doc-styling">
                                    <div className="input-box form-floating">
                                        <input
                                            type="text"
                                            placeholder="Enter TAN Number"
                                            className="form-control input-text form-control-sm"
                                            name="tanNum"
                                            value={cafDocData?.tanNum}
                                            disabled={tanDocVerify === "Verified"}
                                            onChange={handleChange}
                                        />
                                        <label htmlFor="tanNumber">TAN Number</label>
                                        {tanDocVerify !== "Verified" && (
                                            <>
                                                <div className="form-check form-check-style">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        value="tanCheck"
                                                        name="tanCheck"
                                                        id="tanCheck"
                                                        checked={isCheckboxChecked.tanCheck}
                                                        onChange={handleCheckboxChange}
                                                    />
                                                    <label className="form-check-label" htmlFor="tanCheck">
                                                        If the document is not available. Please click on the checkbox.
                                                    </label>
                                                </div>

                                                {(isCheckboxChecked.tanCheck || selectedTanDate) ? (
                                                    <>
                                                        <div className='date-div'>
                                                            <label htmlFor="partnerDeedDate" className="date-label-div">
                                                            Expected Document Date
                                                            </label>
                                                        </div>
                                                        <div className="input-box form-floating d-flex align-items-center position-relative"
                                                            style={{
                                                                borderBottom: "1px solid #dee0de",
                                                                width: "100%",
                                                                // maxWidth: "1500px", // Adjust as needed
                                                            }}>
                                                            <DatePicker
                                                                selected={selectedTanDate}
                                                                onChange={(date) => {
                                                                    setSelectedTanDate(date);
                                                                    handleDateChange(
                                                                        { target: { value: date.toISOString().split("T")[0] } },
                                                                        "tanNumber"
                                                                    );
                                                                }}
                                                                filterDate={isWeekday}
                                                                dateFormat="dd-MM-yyyy"
                                                                placeholderText="Select Date"
                                                                className="form-control input-text form-control-sm p-2"
                                                                style={{
                                                                    width: "100%",
                                                                    paddingRight: "40px", // Ensure space for icon
                                                                    maxWidth: "1500px",
                                                                }}
                                                            />
                                                            <i
                                                                className="fa-solid fa-calendar-days position-absolute"
                                                                style={{
                                                                    right: "20px",
                                                                    top: "50%",
                                                                    transform: "translateY(-50%)",
                                                                    color: "#8b8c8b",
                                                                }}
                                                            ></i>
                                                        </div>
                                                    </>
                                                ) : null}
                                                {(selectedTanDate || tanDocVerify !== "Verified") && (
                                                    <div
                                                        className="input-box form-floating mt-3"
                                                        style={{ position: "relative" }}
                                                    >
                                                        <input
                                                            id="tanUpload"
                                                            type="file"
                                                            accept="image/*,application/pdf"
                                                            onChange={(e) => handleFileUpload(e, "tanNumber")}
                                                            style={{ display: "none" }}
                                                        />
                                                        <input
                                                            type="text"
                                                            placeholder=""
                                                            className="form-control input-text form-control-sm mt-1"
                                                            id="tanFileName"
                                                            value={uploadedTanFile || ""}
                                                            readOnly
                                                            onClick={() =>
                                                                document.getElementById("tanUpload").click()
                                                            }
                                                        />
                                                        <i
                                                            className="fa-solid fa-paperclip fa-paper-icon fa-locator"
                                                            onClick={() =>
                                                                document.getElementById("tanUpload").click()
                                                            }
                                                        ></i>
                                                        <label htmlFor="tanFileName" className="paperclip mt-2">
                                                            TAN Document*
                                                        </label>
                                                    </div>
                                                )}
                                            </>
                                        )}
                                    </div>

                                    {/* Verification Status */}
                                    <div className="input-box form-floating">
                                        <div className="p-3 d-flex flex-column flex-sm-row doc-rej">
                                            <span className="mb-2 mb-sm-0">{cafDocData.tanDoc}</span>
                                            &nbsp;
                                            <span className="mb-sm-0 doc-rej-color">
                                                {cafDocData.tanDocRej ? `(${cafDocData.tanDocRej})` : ""}
                                            </span>
                                        </div>

                                        {tanDocVerify && (
                                            <>
                                                {tanDocVerify === "Verified" ? (
                                                    <i
                                                        className="fa-solid fa-check"
                                                        style={{
                                                            position: "absolute",
                                                            right: "20px",
                                                            top: "70%",
                                                            transform: "translateY(-50%)",
                                                            color: "#77c171",
                                                        }}
                                                    ></i>
                                                ) : (
                                                    <i
                                                        className="fa-solid fa-xmark"
                                                        style={{
                                                            position: "absolute",
                                                            right: "20px",
                                                            top: "70%",
                                                            transform: "translateY(-50%)",
                                                            color: "#f20d24",
                                                        }}
                                                    ></i>
                                                )}
                                            </>
                                        )}
                                    </div>
                                </div>
                            }

                            {/* Registration Certificate*/}
                            {(firmType == "1" || firmType == "2") &&
                                <div className="border doc-styling">
                                    <div className="input-box form-floating">
                                        <input
                                            type="text"
                                            placeholder="Enter Registration Number"
                                            className="form-control input-text form-control-sm"
                                            name="tanNum"
                                            disabled={registationDocVerify === "Verified"}
                                            value={cafDocData.registationNum}
                                            onChange={handleChange}
                                        />
                                        <label htmlFor="tanNum">Registration Certificate</label>
                                        {registationDocVerify !== "Verified" && (
                                            <>
                                                {firmType !== "2" &&
                                                    <div className="form-check form-check-style">
                                                        <input
                                                            className="form-check-input"
                                                            type="checkbox"
                                                            value="registationCheck"
                                                            name="registationCheck"
                                                            id="registationCheck"
                                                            checked={isCheckboxChecked.registationCheck}
                                                            onChange={handleCheckboxChange}
                                                        />
                                                        <label className="form-check-label" htmlFor="registationCheck">
                                                            If the document is not available. Please click on the checkbox.
                                                        </label>
                                                    </div>}

                                                {(isCheckboxChecked.registationCheck || selectedRegDate) ? (
                                                    <>
                                                        <div className='date-div'>
                                                            <label htmlFor="partnerDeedDate" className="date-label-div">
                                                            Expected Document Date
                                                            </label>
                                                        </div>
                                                        <div className="input-box form-floating d-flex align-items-center position-relative"
                                                            style={{
                                                                borderBottom: "1px solid #dee0de",
                                                                width: "100%",
                                                                // maxWidth: "1500px", // Adjust as needed
                                                            }}>
                                                            <DatePicker
                                                                selected={selectedRegDate}
                                                                onChange={(date) => {
                                                                    setSelectedRegDate(date);
                                                                    handleDateChange(
                                                                        { target: { value: date.toISOString().split("T")[0] } },
                                                                        "registationNumber"
                                                                    );
                                                                }}
                                                                filterDate={isWeekday}
                                                                dateFormat="dd-MM-yyyy"
                                                                placeholderText="Select Date"
                                                                className="form-control input-text form-control-sm p-2"
                                                                style={{
                                                                    width: "100%",
                                                                    paddingRight: "40px", // Ensure space for icon
                                                                    maxWidth: "1500px",
                                                                }}
                                                            />
                                                            <i
                                                                className="fa-solid fa-calendar-days position-absolute"
                                                                style={{
                                                                    right: "20px",
                                                                    top: "50%",
                                                                    transform: "translateY(-50%)",
                                                                    color: "#8b8c8b",
                                                                }}
                                                            ></i>
                                                        </div>
                                                    </>
                                                ) : null}
                                                {(selectedRegDate || registationDocVerify !== "Verified") && (
                                                    <div
                                                        className="input-box form-floating mt-3"
                                                        style={{ position: "relative" }}
                                                    >
                                                        <input
                                                            id="registationUpload"
                                                            type="file"
                                                            accept="image/*,application/pdf"
                                                            onChange={(e) => handleFileUpload(e, "registationNumber")}
                                                            style={{ display: "none" }}
                                                        />
                                                        <input
                                                            type="text"
                                                            placeholder=""
                                                            className="form-control input-text form-control-sm mt-1"
                                                            id="registationText"
                                                            value={uploadedRegFile}
                                                            readOnly
                                                            onClick={() =>
                                                                document.getElementById("registationUpload").click()
                                                            }
                                                        />
                                                        <i
                                                            className="fa-solid fa-paperclip fa-paper-icon fa-locator"
                                                            onClick={() =>
                                                                document.getElementById("registationUpload").click()
                                                            }
                                                        ></i>
                                                        <label htmlFor="registationText" className="paperclip mt-2">
                                                            Registration Certificate*
                                                        </label>
                                                    </div>
                                                )}
                                            </>
                                        )}

                                        {(!uploadedRegFile && registationDocVerify !== "Verified" && firmType == "2") &&
                                            <div className="req-color">&nbsp;Required Field*</div>}
                                    </div>


                                    <div className="input-box form-floating">
                                        <div className="p-3 d-flex flex-column flex-sm-row doc-rej">
                                            <span className="mb-2 mb-sm-0">{cafDocData.registationDoc}</span>
                                            &nbsp;
                                            <span className="mb-sm-0 doc-rej-color">
                                                {cafDocData.registationDocRej
                                                    ? `(${cafDocData.registationDocRej})`
                                                    : ""}
                                            </span>
                                        </div>

                                        {registationDocVerify && (
                                            <>
                                                {registationDocVerify === "Verified" ? (
                                                    <i
                                                        className="fa-solid fa-check"
                                                        style={{
                                                            position: "absolute",
                                                            right: "20px",
                                                            top: "70%",
                                                            transform: "translateY(-50%)",
                                                            color: "#77c171",
                                                        }}
                                                    ></i>
                                                ) : (
                                                    <i
                                                        className="fa-solid fa-xmark"
                                                        style={{
                                                            position: "absolute",
                                                            right: "20px",
                                                            top: "70%",
                                                            transform: "translateY(-50%)",
                                                            color: "#f20d24",
                                                        }}
                                                    ></i>
                                                )}
                                            </>
                                        )}
                                    </div>
                                </div>
                            }

                            {/* Auth Latter*/}
                            <div className="border mt-2 doc-styling">
                                <div className="input-box form-floating">
                                    <input
                                        type="text"
                                        placeholder="Enter Authorisation Letter"
                                        className="form-control input-text form-control-sm"
                                        name="authLetterNum"
                                        value={cafDocData.authLetterNum}
                                        disabled={authLetterDocVerify === "Verified"}
                                        onChange={handleChange}
                                    />
                                    <label htmlFor="authLetterNum">Authorisation Letter</label>

                                    {authLetterDocVerify !== "Verified" && (
                                        <>
                                            {/* Checkbox for unavailable document */}
                                            {firmType !== "3" &&
                                                <div className="form-check form-check-style">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        value="authLetterCheck"
                                                        name="authLetterCheck"
                                                        id="authLetterCheck"
                                                        checked={isCheckboxChecked.authLetterCheck}
                                                        onChange={handleCheckboxChange}
                                                    />
                                                    <label
                                                        className="form-check-label"
                                                        htmlFor="authLetterCheck"
                                                    >
                                                        If the document is not available. Please click on the checkbox.
                                                    </label>
                                                </div>}

                                            {/* Conditional input fields for date or file upload */}
                                            {(isCheckboxChecked.authLetterCheck || selectedAuthDate) ? (
                                                <>
                                                    <div className='date-div'>
                                                        <label htmlFor="partnerDeedDate" className="date-label-div">
                                                        Expected Document Date
                                                        </label>
                                                    </div>
                                                    <div
                                                        className="input-box form-floating d-flex align-items-center position-relative"
                                                        style={{
                                                            borderBottom: "1px solid #dee0de",
                                                            width: "100%",
                                                            // maxWidth: "1500px", // Adjust as needed
                                                        }}>
                                                        <DatePicker
                                                            selected={selectedAuthDate}
                                                            onChange={(date) => {
                                                                setSelectedAuthDate(date);
                                                                handleDateChange(
                                                                    { target: { value: date.toISOString().split("T")[0] } },
                                                                    "authorisationLetter"
                                                                );
                                                            }}
                                                            filterDate={isWeekday}
                                                            dateFormat="dd-MM-yyyy"
                                                            placeholderText="Select Date"
                                                            className="form-control input-text form-control-sm p-2"
                                                            style={{
                                                                width: "100%",
                                                                paddingRight: "40px", // Ensure space for icon
                                                                maxWidth: "1500px",
                                                            }}
                                                        />
                                                        <i
                                                            className="fa-solid fa-calendar-days position-absolute"
                                                            style={{
                                                                right: "20px",
                                                                top: "50%",
                                                                transform: "translateY(-50%)",
                                                                color: "#8b8c8b",
                                                            }}
                                                        ></i>
                                                    </div>
                                                </>

                                            ) : null}
                                            {(selectedAuthDate || authLetterDocVerify !== "Verified") && (
                                                <div
                                                    className="input-box form-floating mt-3"
                                                    style={{ position: "relative" }}
                                                >
                                                    <input
                                                        id="authLetterUpload"
                                                        type="file"
                                                        accept="image/*,application/pdf"
                                                        onChange={(e) =>
                                                            handleFileUpload(e, "authorisationLetter")
                                                        }
                                                        style={{ display: "none" }}
                                                    />
                                                    <input
                                                        type="text"
                                                        className="form-control input-text form-control-sm"
                                                        value={uploadedAuthFile}
                                                        readOnly
                                                        onClick={() =>
                                                            document.getElementById("authLetterUpload").click()
                                                        }
                                                    />
                                                    <i
                                                        className="fa-solid fa-paperclip fa-paper-icon fa-locator"
                                                        onClick={() =>
                                                            document.getElementById("authLetterUpload").click()
                                                        }
                                                    ></i>
                                                    <label
                                                        htmlFor="authLetterUpload"
                                                        className="paperclip mt-2"
                                                    >
                                                        Upload Authorisation Letter*
                                                    </label>
                                                </div>
                                            )}
                                        </>
                                    )}
                                    {(!uploadedAuthFile && authLetterDocVerify !== "Verified" && autherName && (firmType == "3" || firmType == "4")) &&
                                        <div className="req-color">&nbsp;Required Field*</div>}
                                </div>

                                {/* Authorisation Letter Document Verification Status */}
                                <div className="input-box form-floating">
                                    <div className="p-3 d-flex flex-column flex-sm-row doc-rej">
                                        <span className="mb-2 mb-sm-0">{cafDocData.authLetterDoc}</span>&nbsp;
                                        <span className="mb-sm-0 doc-rej-color">
                                            {cafDocData.authDocRej
                                                ? `(${cafDocData.authDocRej})`
                                                : ""}
                                        </span>
                                    </div>

                                    {authLetterDocVerify && (
                                        <>
                                            {authLetterDocVerify === "Verified" ? (
                                                <i
                                                    className="fa-solid fa-check"
                                                    style={{
                                                        position: "absolute",
                                                        right: "20px",
                                                        top: "70%",
                                                        transform: "translateY(-50%)",
                                                        color: "#77c171",
                                                    }}
                                                ></i>
                                            ) : (
                                                <i
                                                    className="fa-solid fa-xmark"
                                                    style={{
                                                        position: "absolute",
                                                        right: "20px",
                                                        top: "70%",
                                                        transform: "translateY(-50%)",
                                                        color: "#f20d24",
                                                    }}
                                                ></i>
                                            )}
                                        </>
                                    )}
                                </div>
                            </div>


                            {/* POI */}
                            {/* <div className="border mt-2 doc-styling">
                                <div className="input-box form-floating">
                                    <input
                                        type="text"
                                        placeholder="Enter Photo Proof Number"
                                        className="form-control input-text form-control-sm"
                                        name="poiNum"
                                        value={cafDocData.poiNum}
                                        disabled={poiDocVerify === "Verified"}
                                        onChange={handleChange}
                                    />
                                    <label htmlFor="poiNum">POI</label>
                                </div>

                                <div>
                                    <label className="select-search-label mt-1">POI</label>
                                    <Select
                                        className="basic-single form-control form-control-sm p-1"
                                        classNamePrefix="select"
                                        name="poi"
                                        placeholder="Select Option"
                                        styles={style}
                                        value={selectPoi}
                                        isSearchable={false}
                                        onChange={handleSelectPoi}
                                        options={optionPoi.map((data) => ({
                                            value: data.value,
                                            label: data.label,
                                        }))}
                                    />

                                    {photoDocVerify !== "Verified" && (
                                        <>
                                          
                                            <div className="form-check form-check-style mt-2">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    value="poiCheck"
                                                    name="poiCheck"
                                                    id="poiCheck"
                                                    checked={isCheckboxChecked.poiCheck}
                                                    onChange={handleCheckboxChange}
                                                />
                                                <label
                                                    className="form-check-label"
                                                    htmlFor="poiCheck"
                                                >
                                                    If the document is not available. Please click on the checkbox.
                                                </label>
                                            </div>

                                           
                                            {isCheckboxChecked.poiCheck ? (
                                                <div className="input-box form-floating mt-2">
                                                    <input
                                                        type="date"
                                                        className="form-control input-text form-control-sm"
                                                        id="poiDate"
                                                        name="poiDate"
                                                        value={cafDocData.poidate}
                                                        onChange={(e) => handleDateChange(e, "poi")}
                                                        max={maxDate}
                                                        min={minDate}
                                                    />
                                                    <label htmlFor="poiDate" className="p-2">
                                                        Expected Document Date
                                                    </label>
                                                </div>
                                            ) : (
                                                <div
                                                    className="input-box form-floating mt-2"
                                                    style={{ position: "relative" }}
                                                >
                                                    <input
                                                        id="poiUpload"
                                                        type="file"
                                                        accept=".pdf,.jpg,.jpeg,.png"
                                                        onChange={(e) => handleFileUpload(e, "poi")}
                                                        style={{ display: "none" }}
                                                    />
                                                    <input
                                                        type="text"
                                                        className="form-control input-text form-control-sm"
                                                        value={uploadedPoiFile}
                                                        readOnly
                                                        onClick={() =>
                                                            document
                                                                .getElementById("poiUpload")
                                                                .click()
                                                        }
                                                    />
                                                    <i
                                                        className="fa-solid fa-paperclip fa-paper-icon fa-locator"
                                                        onClick={() =>
                                                            document
                                                                .getElementById("poiUpload")
                                                                .click()
                                                        }
                                                    ></i>
                                                    <label
                                                        htmlFor="poiUpload"
                                                        className="paperclip mt-2"
                                                    >
                                                        POI*
                                                    </label>
                                                </div>
                                            )}
                                        </>
                                    )}
                                </div>

                               
                                <div className="input-box form-floating mt-3">
                                    <div className="p-3 d-flex flex-column flex-sm-row doc-rej">
                                        <span className="mb-2 mb-sm-0">{cafDocData.poiDoc}</span>&nbsp;
                                        <span className="mb-sm-0 doc-rej-color">
                                            {cafDocData.poiDocRej
                                                ? `(${cafDocData.poiDocRej})`
                                                : ""}
                                        </span>
                                    </div>

                                    {poiDocVerify && (
                                        <>
                                            {poiDocVerify === "Verified" ? (
                                                <i
                                                    className="fa-solid fa-check"
                                                    style={{
                                                        position: "absolute",
                                                        right: "20px",
                                                        top: "70%",
                                                        transform: "translateY(-50%)",
                                                        color: "#77c171",
                                                    }}
                                                ></i>
                                            ) : (
                                                <i
                                                    className="fa-solid fa-xmark"
                                                    style={{
                                                        position: "absolute",
                                                        right: "20px",
                                                        top: "70%",
                                                        transform: "translateY(-50%)",
                                                        color: "#f20d24",
                                                    }}
                                                ></i>
                                            )}
                                        </>
                                    )}
                                </div>
                            </div> */}


                            {/* Photo Proof */}
                            <div className="border mt-2 doc-styling">
                                <div className="input-box form-floating">
                                    <input
                                        type="text"
                                        placeholder="Enter Photo Proof Number"
                                        className="form-control input-text form-control-sm"
                                        name="photoProofNum"
                                        value={cafDocData.photoProofNum}
                                        disabled={photoDocVerify === "Verified"}
                                        onChange={handleChange}
                                    />
                                    <label htmlFor="photoProofNum">Photo Proof Number Of Authorised Person</label>
                                </div>

                                <div>
                                    <label className="select-search-label mt-1">Photo Proof Of Authorised Person</label>
                                    <Select
                                        className="basic-single form-control form-control-sm p-1"
                                        classNamePrefix="select"
                                        name="photoProof"
                                        placeholder="Select Option"
                                        styles={style}
                                        value={selectPhotoProof}
                                        isSearchable={false}
                                        onChange={handleSelectPhotoProof}
                                        options={optionPhotoProof.map((data) => ({
                                            value: data.value,
                                            label: data.label,
                                        }))}
                                    />

                                    {photoDocVerify !== "Verified" && (
                                        <>
                                            {firmType == "5" &&
                                                <div className="form-check form-check-style mt-2">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        value="photoProofCheck"
                                                        name="photoProofCheck"
                                                        id="photoProofCheck"
                                                        checked={isCheckboxChecked.photoProofCheck}
                                                        onChange={handleCheckboxChange}
                                                    />
                                                    <label
                                                        className="form-check-label"
                                                        htmlFor="photoProofCheck"
                                                    >
                                                        If the document is not available. Please click on the checkbox.
                                                    </label>
                                                </div>}

                                            {(isCheckboxChecked.photoProofCheck || selectedPhotoProofDate) ? (
                                                <>
                                                    <div className='date-div'>
                                                        <label htmlFor="partnerDeedDate" className="date-label-div">
                                                        Expected Document Date
                                                        </label>
                                                    </div>
                                                    <div className="input-box form-floating d-flex align-items-center position-relative"
                                                        style={{
                                                            borderBottom: "1px solid #dee0de",
                                                            width: "100%",
                                                            // maxWidth: "1500px", // Adjust as needed
                                                        }}>
                                                        <DatePicker
                                                            selected={selectedPhotoProofDate}
                                                            onChange={(date) => {
                                                                setSelectedPhotoProofDate(date);
                                                                handleDateChange(
                                                                    { target: { value: date.toISOString().split("T")[0] } },
                                                                    "photoProof"
                                                                );
                                                            }}
                                                            filterDate={isWeekday}
                                                            dateFormat="dd-MM-yyyy"
                                                            placeholderText="Select Date"
                                                            className="form-control input-text form-control-sm p-2"
                                                            style={{
                                                                width: "100%",
                                                                paddingRight: "40px", // Ensure space for icon
                                                                maxWidth: "1500px",
                                                            }}
                                                        />
                                                        <i
                                                            className="fa-solid fa-calendar-days position-absolute"
                                                            style={{
                                                                right: "20px",
                                                                top: "50%",
                                                                transform: "translateY(-50%)",
                                                                color: "#8b8c8b",
                                                            }}
                                                        ></i>
                                                    </div>
                                                </>
                                            ) : null}
                                            {(selectedPhotoProofDate || photoDocVerify !== "Verified") && (
                                                <div
                                                    className="input-box form-floating mt-2"
                                                    style={{ position: "relative" }}
                                                >
                                                    <input
                                                        id="photoProofUpload"
                                                        type="file"
                                                        accept=".pdf,.jpg,.jpeg,.png"
                                                        onChange={(e) => handleFileUpload(e, "photoProof")}
                                                        style={{ display: "none" }}
                                                    />
                                                    <input
                                                        type="text"
                                                        className="form-control input-text form-control-sm"
                                                        value={uploadedPhotoFile}
                                                        readOnly
                                                        onClick={() =>
                                                            document
                                                                .getElementById("photoProofUpload")
                                                                .click()
                                                        }
                                                    />
                                                    <i
                                                        className="fa-solid fa-paperclip fa-paper-icon fa-locator"
                                                        onClick={() =>
                                                            document
                                                                .getElementById("photoProofUpload")
                                                                .click()
                                                        }
                                                    ></i>
                                                    <label
                                                        htmlFor="photoProofUpload"
                                                        className="paperclip mt-2"
                                                    >
                                                        Upload Photo Proof Of Authorised Person*
                                                    </label>
                                                </div>
                                            )}
                                        </>
                                    )}

                                    {(!uploadedPhotoFile && photoDocVerify !== "Verified" && autherName && firmType !== "5") &&
                                        <div className='req-color'>&nbsp;Required Field*</div>}
                                </div>

                                {/* Photo Proof Document Verification Status */}
                                <div className="input-box form-floating mt-3">
                                    <div className="p-3 d-flex flex-column flex-sm-row doc-rej">
                                        <span className="mb-2 mb-sm-0">{cafDocData.photoProofDoc}</span>&nbsp;
                                        <span className="mb-sm-0 doc-rej-color">
                                            {cafDocData.photoDocRej
                                                ? `(${cafDocData.photoDocRej})`
                                                : ""}
                                        </span>
                                    </div>

                                    {photoDocVerify && (
                                        <>
                                            {photoDocVerify === "Verified" ? (
                                                <i
                                                    className="fa-solid fa-check"
                                                    style={{
                                                        position: "absolute",
                                                        right: "20px",
                                                        top: "70%",
                                                        transform: "translateY(-50%)",
                                                        color: "#77c171",
                                                    }}
                                                ></i>
                                            ) : (
                                                <i
                                                    className="fa-solid fa-xmark"
                                                    style={{
                                                        position: "absolute",
                                                        right: "20px",
                                                        top: "70%",
                                                        transform: "translateY(-50%)",
                                                        color: "#f20d24",
                                                    }}
                                                ></i>
                                            )}
                                        </>
                                    )}
                                </div>
                            </div>


                            {/* Address Proof */}
                            <div className="border mt-2 doc-styling">
                                <div className="input-box form-floating">
                                    <input
                                        type="text"
                                        placeholder="Enter Address Proof Number"
                                        className="form-control input-text form-control-sm"
                                        name="addressProofNum"
                                        value={cafDocData.addressProofNum}
                                        disabled={addressDocVerify === "Verified"}
                                        onChange={handleChange}
                                    />
                                    <label htmlFor="addressProofNum">Address Proof Number</label>
                                </div>

                                <div>
                                    <label className="select-search-label mt-1">Address Proof</label>
                                    <Select
                                        className="basic-single form-control form-control-sm p-1"
                                        classNamePrefix="select"
                                        name="addressProof"
                                        placeholder="Select Option"
                                        styles={style}
                                        value={selectAddressProof}
                                        isSearchable={false}
                                        onChange={handleSelectAddressProof}
                                        options={optionAddressProof.map((data) => ({
                                            value: data.value,
                                            label: data.label,
                                        }))}
                                    />
                                    {addressDocVerify !== "Verified" && (
                                        <>
                                            {/* Checkbox for unavailable document */}
                                            {firmType !== "6" &&
                                                <div className="form-check form-check-style">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        value="addressProofCheck"
                                                        name="addressProofCheck"
                                                        id="addressProofCheck"
                                                        checked={isCheckboxChecked.addressProofCheck}
                                                        onChange={handleCheckboxChange}
                                                    />
                                                    <label
                                                        className="form-check-label"
                                                        htmlFor="addressProofCheck"
                                                    >
                                                        If the document is not available. Please click on the checkbox.
                                                    </label>
                                                </div>}

                                            {/* Conditional input fields for date or file upload */}
                                            {(isCheckboxChecked.addressProofCheck || selectedAddressProofDate) ? (
                                                <>
                                                    <div className='date-div'>
                                                        <label htmlFor="partnerDeedDate" className="date-label-div">
                                                        Expected Document Date
                                                        </label>
                                                    </div>
                                                    <div className="input-box form-floating d-flex align-items-center position-relative"
                                                        style={{
                                                            borderBottom: "1px solid #dee0de",
                                                            width: "100%",
                                                            // maxWidth: "1500px", // Adjust as needed
                                                        }}>
                                                        <DatePicker
                                                            selected={selectedAddressProofDate}
                                                            onChange={(date) => {
                                                                setSelectedAddressProofDate(date);
                                                                handleDateChange(
                                                                    { target: { value: date.toISOString().split("T")[0] } },
                                                                    "addressProof"
                                                                );
                                                            }}
                                                            filterDate={isWeekday}
                                                            dateFormat="dd-MM-yyyy"
                                                            placeholderText="Select Date"
                                                            className="form-control input-text form-control-sm p-2"
                                                            style={{
                                                                width: "100%",
                                                                paddingRight: "40px", // Ensure space for icon
                                                                maxWidth: "1500px",
                                                            }}
                                                        />
                                                        <i
                                                            className="fa-solid fa-calendar-days position-absolute"
                                                            style={{
                                                                right: "20px",
                                                                top: "50%",
                                                                transform: "translateY(-50%)",
                                                                color: "#8b8c8b",
                                                            }}
                                                        ></i>
                                                    </div>
                                                </>
                                            ) : null}
                                            {(selectedAddressProofDate || addressDocVerify !== "Verified") && (
                                                <div
                                                    className="input-box form-floating mt-3"
                                                    style={{ position: "relative" }}
                                                >
                                                    <input
                                                        id="addressProofUpload"
                                                        type="file"
                                                        accept="image/*,application/pdf"
                                                        onChange={(e) =>
                                                            handleFileUpload(e, "addressProof")
                                                        }
                                                        style={{ display: "none" }}
                                                    />
                                                    <input
                                                        type="text"
                                                        className="form-control input-text form-control-sm"
                                                        value={uploadedAddressFile}
                                                        readOnly
                                                        onClick={() =>
                                                            document.getElementById(
                                                                "addressProofUpload"
                                                            ).click()
                                                        }
                                                    />
                                                    <i
                                                        className="fa-solid fa-paperclip fa-paper-icon fa-locator"
                                                        onClick={() =>
                                                            document.getElementById(
                                                                "addressProofUpload"
                                                            ).click()
                                                        }
                                                    ></i>
                                                    <label
                                                        htmlFor="addressProofUpload"
                                                        className="paperclip mt-2"
                                                    >
                                                        Upload Address Proof*
                                                    </label>
                                                </div>
                                            )}
                                        </>
                                    )}
                                    {(!uploadedAddressFile && addressDocVerify !== "Verified" && firmType == "6") &&
                                        <div className='req-color'>&nbsp;Required Field*</div>}
                                </div>

                                {/* Address Proof Document Verification Status */}
                                <div className="input-box form-floating">
                                    <div className="p-3 d-flex flex-column flex-sm-row doc-rej">
                                        <span className="mb-2 mb-sm-0">{cafDocData.addressProofDoc}</span>&nbsp;
                                        <span className="mb-sm-0 doc-rej-color">
                                            {cafDocData.addressDocRej
                                                ? `(${cafDocData.addressDocRej})`
                                                : ""}
                                        </span>
                                    </div>

                                    {addressDocVerify && (
                                        <>
                                            {addressDocVerify === "Verified" ? (
                                                <i
                                                    className="fa-solid fa-check"
                                                    style={{
                                                        position: "absolute",
                                                        right: "20px",
                                                        top: "70%",
                                                        transform: "translateY(-50%)",
                                                        color: "#77c171",
                                                    }}
                                                ></i>
                                            ) : (
                                                <i
                                                    className="fa-solid fa-xmark"
                                                    style={{
                                                        position: "absolute",
                                                        right: "20px",
                                                        top: "70%",
                                                        transform: "translateY(-50%)",
                                                        color: "#f20d24",
                                                    }}
                                                ></i>
                                            )}
                                        </>
                                    )}
                                </div>
                            </div>



                            {/* Purchase Order new*/}
                            <div className="border mt-2 doc-styling">
                                <div className="input-box form-floating">
                                    <input
                                        type="text"
                                        placeholder="Enter Authorisation Letter"
                                        className="form-control input-text form-control-sm"
                                        name="poNum"
                                        value={cafDocData.poNum}
                                        disabled={poDocVerify === "Verified"}
                                        onChange={handleChange}
                                    />
                                    <label htmlFor="authLetterNum">Purchase Order</label>

                                    {poDocVerify !== "Verified" && (
                                        <>
                                            {/* Checkbox for unavailable document */}
                                            {false &&
                                                <div className="form-check form-check-style">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        value="poCheck"
                                                        name="poCheck"
                                                        id="poCheck"
                                                        checked={isCheckboxChecked.poCheck}
                                                        onChange={handleCheckboxChange}
                                                    />
                                                    <label
                                                        className="form-check-label"
                                                        htmlFor="poCheck"
                                                    >
                                                        If the document is not available. Please click on the checkbox.
                                                    </label>
                                                </div>
                                            }

                                            {/* Conditional input fields for date or file upload */}
                                            {(isCheckboxChecked.poCheck || selectedPoDate) ? (
                                                <>
                                                    <div className='date-div'>
                                                        <label htmlFor="partnerDeedDate" className="date-label-div">
                                                        Expected Document Date
                                                        </label>
                                                    </div>
                                                    <div
                                                        className="input-box form-floating d-flex align-items-center position-relative"
                                                        style={{
                                                            borderBottom: "1px solid #dee0de",
                                                            width: "100%",
                                                            // maxWidth: "1500px", // Adjust as needed
                                                        }}>
                                                        <DatePicker
                                                            selected={selectedPoDate}
                                                            onChange={(date) => {
                                                                setSelectedPoDate(date);
                                                                handleDateChange(
                                                                    { target: { value: date.toISOString().split("T")[0] } },
                                                                    "po"
                                                                );
                                                            }}
                                                            filterDate={isWeekday}
                                                            dateFormat="dd-MM-yyyy"
                                                            placeholderText="Select Date"
                                                            className="form-control input-text form-control-sm p-2"
                                                            style={{
                                                                width: "100%",
                                                                paddingRight: "40px", // Ensure space for icon
                                                                maxWidth: "1500px",
                                                            }}
                                                        />
                                                        <i
                                                            className="fa-solid fa-calendar-days position-absolute"
                                                            style={{
                                                                right: "20px",
                                                                top: "50%",
                                                                transform: "translateY(-50%)",
                                                                color: "#8b8c8b",
                                                            }}
                                                        ></i>
                                                    </div>
                                                </>

                                            ) : null}
                                            {(selectedPoDate || poDocVerify !== "Verified") && (
                                                <div
                                                    className="input-box form-floating mt-3"
                                                    style={{ position: "relative" }}
                                                >
                                                    <input
                                                        id="poUpload"
                                                        type="file"
                                                        accept="image/*,application/pdf"
                                                        onChange={(e) =>
                                                            handleFileUpload(e, "po")
                                                        }
                                                        style={{ display: "none" }}
                                                    />
                                                    <input
                                                        type="text"
                                                        className="form-control input-text form-control-sm"
                                                        value={uploadedPurchseFile}
                                                        readOnly
                                                        onClick={() =>
                                                            document.getElementById("poUpload").click()
                                                        }
                                                    />
                                                    <i
                                                        className="fa-solid fa-paperclip fa-paper-icon fa-locator"
                                                        onClick={() =>
                                                            document.getElementById("poUpload").click()
                                                        }
                                                    ></i>
                                                    <label
                                                        htmlFor="authLetterUpload"
                                                        className="paperclip mt-2"
                                                    >
                                                        Upload PO Letter*
                                                    </label>
                                                </div>
                                            )}
                                        </>
                                    )}
                                    {(!uploadedPurchseFile && poDocVerify !== "Verified") &&
                                        <div className="req-color">&nbsp;Required Field*</div>}
                                </div>

                                {/* Authorisation Letter Document Verification Status */}
                                <div className="input-box form-floating">
                                    <div className="p-3 d-flex flex-column flex-sm-row doc-rej">
                                        <span className="mb-2 mb-sm-0">{cafDocData.poDoc}</span>&nbsp;
                                        <span className="mb-sm-0 doc-rej-color">
                                            {cafDocData.poDocRej ? `(${cafDocData.poDocRej})` : ""}
                                        </span>
                                    </div>

                                    {poDocVerify && (
                                        <>
                                            {poDocVerify === "Verified" ? (
                                                <i
                                                    className="fa-solid fa-check"
                                                    style={{
                                                        position: "absolute",
                                                        right: "20px",
                                                        top: "70%",
                                                        transform: "translateY(-50%)",
                                                        color: "#77c171",
                                                    }}
                                                ></i>
                                            ) : (
                                                <i
                                                    className="fa-solid fa-xmark"
                                                    style={{
                                                        position: "absolute",
                                                        right: "20px",
                                                        top: "70%",
                                                        transform: "translateY(-50%)",
                                                        color: "#f20d24",
                                                    }}
                                                ></i>
                                            )}
                                        </>
                                    )}
                                </div>
                            </div>




                            {/* Network Diagram*/}
                            {getopportunity?.ProductSegment == 'ILL' || getopportunity?.ProductSegment == 'BIA' &&
                                <div className="border mt-2 doc-styling">
                                    <div className="input-box form-floating">
                                        <input
                                            type="text"
                                            placeholder="Enter Authorisation Letter"
                                            className="form-control input-text form-control-sm"
                                            name="networkNum"
                                            value={cafDocData.networkNum}
                                            disabled={networkDocVerify === "Verified"}
                                            onChange={handleChange}
                                        />
                                        <label htmlFor="networkNum">Network Diagram</label>

                                        {networkDocVerify !== "Verified" && (
                                            <>
                                                {/* Checkbox for unavailable document */}
                                                {false &&
                                                    <div className="form-check form-check-style">
                                                        <input
                                                            className="form-check-input"
                                                            type="checkbox"
                                                            value="networkCheck"
                                                            name="networkCheck"
                                                            id="networkCheck"
                                                            checked={isCheckboxChecked.networkCheck}
                                                            onChange={handleCheckboxChange}
                                                        />
                                                        <label
                                                            className="form-check-label"
                                                            htmlFor="networkCheck"
                                                        >
                                                            If the document is not available. Please click on the checkbox.
                                                        </label>
                                                    </div>
                                                }

                                                {/* Conditional input fields for date or file upload */}
                                                {(isCheckboxChecked.networkCheck || selectedNetworkDate) ? (
                                                    <>
                                                        <div className='date-div'>
                                                            <label htmlFor="networkDate" className="date-label-div">
                                                            Expected Document Date
                                                            </label>
                                                        </div>
                                                        <div
                                                            className="input-box form-floating d-flex align-items-center position-relative"
                                                            style={{
                                                                borderBottom: "1px solid #dee0de",
                                                                width: "100%",
                                                                // maxWidth: "1500px", // Adjust as needed
                                                            }}>
                                                            <DatePicker
                                                                selected={selectedNetworkDate}
                                                                onChange={(date) => {
                                                                    setSelectedNetworkDate(date);
                                                                    handleDateChange(
                                                                        { target: { value: date.toISOString().split("T")[0] } },
                                                                        "networkDiagram"
                                                                    );
                                                                }}
                                                                filterDate={isWeekday}
                                                                dateFormat="dd-MM-yyyy"
                                                                placeholderText="Select Date"
                                                                className="form-control input-text form-control-sm p-2"
                                                                style={{
                                                                    width: "100%",
                                                                    paddingRight: "40px", // Ensure space for icon
                                                                    maxWidth: "1500px",
                                                                }}
                                                            />
                                                            <i
                                                                className="fa-solid fa-calendar-days position-absolute"
                                                                style={{
                                                                    right: "20px",
                                                                    top: "50%",
                                                                    transform: "translateY(-50%)",
                                                                    color: "#8b8c8b",
                                                                }}
                                                            ></i>
                                                        </div>
                                                    </>

                                                ) : null}
                                                {(selectedNetworkDate || networkDocVerify !== "Verified") && (
                                                    <div
                                                        className="input-box form-floating mt-3"
                                                        style={{ position: "relative" }}
                                                    >
                                                        <input
                                                            id="networkUpload"
                                                            type="file"
                                                            accept="image/*,application/pdf"
                                                            onChange={(e) =>
                                                                handleFileUpload(e, "networkDiagram")
                                                            }
                                                            style={{ display: "none" }}
                                                        />
                                                        <input
                                                            type="text"
                                                            className="form-control input-text form-control-sm"
                                                            value={uploadedNetworkFile}
                                                            readOnly
                                                            onClick={() =>
                                                                document.getElementById("networkUpload").click()
                                                            }
                                                        />
                                                        <i
                                                            className="fa-solid fa-paperclip fa-paper-icon fa-locator"
                                                            onClick={() =>
                                                                document.getElementById("networkUpload").click()
                                                            }
                                                        ></i>
                                                        <label
                                                            htmlFor="networkUpload"
                                                            className="paperclip mt-2"
                                                        >
                                                            Upload Network Diagram Letter*
                                                        </label>
                                                    </div>
                                                )}
                                            </>
                                        )}
                                        {/* {(!uploadedNetworkFile && networkDocVerify !== "Verified") &&
                                            <div className="req-color">&nbsp;Required Field*</div>} */}
                                            {!cafDocData.networkDoc &&
                                            <div className="req-color">&nbsp;Required Field*</div>}
                                    </div>

                                    {/* Authorisation Letter Document Verification Status */}
                                    <div className="input-box form-floating">
                                        <div className="p-3 d-flex flex-column flex-sm-row doc-rej">
                                            <span className="mb-2 mb-sm-0">{cafDocData.networkDoc}</span>&nbsp;
                                            <span className="mb-sm-0 doc-rej-color">
                                                {cafDocData.networkDocRej ? `(${cafDocData.networkDocRej})` : ""}
                                            </span>
                                        </div>

                                        {networkDocVerify && (
                                            <>
                                                {poDocVerify === "Verified" ? (
                                                    <i
                                                        className="fa-solid fa-check"
                                                        style={{
                                                            position: "absolute",
                                                            right: "20px",
                                                            top: "70%",
                                                            transform: "translateY(-50%)",
                                                            color: "#77c171",
                                                        }}
                                                    ></i>
                                                ) : (
                                                    <i
                                                        className="fa-solid fa-xmark"
                                                        style={{
                                                            position: "absolute",
                                                            right: "20px",
                                                            top: "70%",
                                                            transform: "translateY(-50%)",
                                                            color: "#f20d24",
                                                        }}
                                                    ></i>
                                                )}
                                            </>
                                        )}
                                    </div>
                                </div>
                            }

                        </form>


                        {/* <div className="text-center">
                            <button
                                type="button"
                                className="btn text-light bg-dark mx-auto submit-btn rounded-pill mb-4"
                                onClick={handleSubmitDocument}
                            disabled={Object.keys(isSubmitSucess).length === 0}
                            >
                                Submit Documents
                            </button>
                        </div> */}


                        {/* <div className="text-center">
                            <button
                                type="submit"
                                className="btn text-light bg-dark mx-auto submit-btn rounded-pill"
                                onClick={handleSubmitDoc}
                            >
                                Submit Document
                            </button>
                        </div> */}




                        {/* <div className="text-center mt-5">
                            <button
                                type="button"
                                className="btn text-light bg-dark mx-auto submit-btn rounded-pill mb-4"
                                onClick={handleGenerateOTPforSel}
                            >
                                Generate Otp
                            </button>
                            <button
                                type="button"
                                className="btn text-light bg-dark mx-auto submit-btn rounded-pill mb-4"
                                onClick={handleResendEmailToCust}
                            >
                                Resend Email
                            </button>
                        </div> */}

                    </div>)}
            </div>

        </>
    )
}

export default BusinessSAFmanageFormDOC;


